import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LabelAndCode: { input: any; output: any; }
  LatLng: { input: any; output: any; }
  MongoSortQuery: { input: any; output: any; }
  ObjectId: { input: string; output: string; }
};

export type AccountData = {
  __typename?: 'AccountData';
  account?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export enum BasicCoverageTypes {
  Custeio = 'custeio',
  Produtividade = 'produtividade',
  RiscoNomeado = 'risco_nomeado'
}

export type Claim = {
  __typename?: 'Claim';
  _id: Scalars['ObjectId']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  documentId: Scalars['ObjectId']['output'];
  endDate: Scalars['Date']['output'];
  events: Array<ClaimEvent>;
  externalId: Scalars['String']['output'];
  lossEstimate: LossEstimate;
  name: Scalars['String']['output'];
  plots?: Maybe<Array<Plot>>;
  startDate: Scalars['Date']['output'];
  status: ClaimStatus;
};

export enum ClaimEvent {
  Drought = 'drought',
  Fire = 'fire',
  Frost = 'frost',
  Hail = 'hail',
  Lightning = 'lightning',
  Rain = 'rain',
  Wind = 'wind'
}

export enum ClaimStatus {
  Approved = 'approved',
  Open = 'open',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type Contact = {
  __typename?: 'Contact';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  addressProofFile?: Maybe<File>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  civilState?: Maybe<Scalars['String']['output']>;
  cpfCnpj?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  documentFile?: Maybe<File>;
  email?: Maybe<Scalars['String']['output']>;
  emissionInstitution?: Maybe<Scalars['String']['output']>;
  emissionInstitutionId?: Maybe<Scalars['ObjectId']['output']>;
  expeditionDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentRelation?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  professionId?: Maybe<Scalars['ObjectId']['output']>;
  rg?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ContactTags {
  Beneficiary = 'beneficiary',
  Consultant = 'consultant',
  Farmer = 'farmer',
  Inspector = 'inspector',
  PaymentResponsible = 'paymentResponsible'
}

export enum CoverageTags {
  Additional = 'additional',
  Basic = 'basic',
  Fire = 'fire',
  Frost = 'frost',
  Hail = 'hail',
  PhytosanitaryTreatment = 'phytosanitary_treatment',
  PlantLife = 'plant_life',
  ProductionLoss = 'production_loss',
  Wind = 'wind'
}

export type Coverages = {
  __typename?: 'Coverages';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  insuranceTypes?: Maybe<Array<Maybe<InsuranceType>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateClaimOnDocumentPayload = {
  documentId: Scalars['String']['input'];
};

export type CreateInspectionOnDocumentPayload = {
  documentId: Scalars['String']['input'];
};

export type CreateMeetingOnObjectPayload = {
  parentId: Scalars['String']['input'];
  serviceName: Services;
};

export type CreatePaymentOnDocumentPayload = {
  documentId: Scalars['String']['input'];
};

export type CreatePolicyOnDocumentPayload = {
  documentId: Scalars['String']['input'];
};

export type CreateProposalOnDocumentPayload = {
  documentId: Scalars['String']['input'];
};

export type CreateResultOnDocumentPayload = {
  documentId: Scalars['String']['input'];
};

export type CreateSignedProposalOnResultPayload = {
  proposalResultId: Scalars['String']['input'];
};

export type Crop = {
  __typename?: 'Crop';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  compositionType?: Maybe<Scalars['LabelAndCode']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropYear?: Maybe<Scalars['String']['output']>;
  culture?: Maybe<Culture>;
  cultureDetail?: Maybe<CultureDetail>;
  cultureDetailId?: Maybe<Scalars['ObjectId']['output']>;
  cultureId?: Maybe<Scalars['ObjectId']['output']>;
  cultureName?: Maybe<Scalars['String']['output']>;
  harvestEndDate?: Maybe<Scalars['Date']['output']>;
  harvestStartDate?: Maybe<Scalars['Date']['output']>;
  kmlFile?: Maybe<File>;
  manualCulture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plots?: Maybe<Array<Plot>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CropInsuranceQuestions = {
  __typename?: 'CropInsuranceQuestions';
  federalSubvention?: Maybe<Scalars['Boolean']['output']>;
  firstCrop?: Maybe<Scalars['Boolean']['output']>;
  isPlanted?: Maybe<Scalars['Boolean']['output']>;
  nightIrrigation?: Maybe<Scalars['Boolean']['output']>;
  organicCulture?: Maybe<Scalars['Boolean']['output']>;
  otherInsurances?: Maybe<Scalars['Boolean']['output']>;
  pronampBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  recentIncident?: Maybe<Scalars['Boolean']['output']>;
  stateSubvention?: Maybe<Scalars['Boolean']['output']>;
  withSubvention?: Maybe<Scalars['Boolean']['output']>;
};

export type Culture = {
  __typename?: 'Culture';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  codMapfre?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CultureDetail = {
  __typename?: 'CultureDetail';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  codMapfre?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  culture?: Maybe<Culture>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DocumentStages {
  Claim = 'claim',
  Policy = 'policy',
  Proposal = 'proposal',
  Quotation = 'quotation',
  Simulation = 'simulation'
}

export enum DocumentStatus {
  Done = 'done',
  Effective = 'effective',
  Incomplete = 'incomplete',
  NonEffective = 'nonEffective',
  Pending = 'pending',
  Rejected = 'rejected',
  Sent = 'sent',
  UnderAnalysis = 'underAnalysis'
}

export type DocumentsFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cultureId?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['JSON']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  responsableId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FieldUpdateResponse = {
  __typename?: 'FieldUpdateResponse';
  error?: Maybe<Scalars['String']['output']>;
  fieldPath: Scalars['String']['output'];
  invisible?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FormDataOptions>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type File = {
  __typename?: 'File';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  fileKey?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

export type FormDataOptions = {
  __typename?: 'FormDataOptions';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type FormRequestResponse = {
  __typename?: 'FormRequestResponse';
  formId: Scalars['String']['output'];
  formResponseId: Scalars['String']['output'];
};

export type FormResponse = {
  __typename?: 'FormResponse';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  formData?: Maybe<Scalars['JSON']['output']>;
  formState?: Maybe<Scalars['JSON']['output']>;
};

export enum FormResponseStatus {
  Editing = 'editing',
  Submited = 'submited'
}

export type Inspection = {
  __typename?: 'Inspection';
  _id: Scalars['ObjectId']['output'];
  claimIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  claims?: Maybe<Array<Maybe<Claim>>>;
  date: Scalars['Date']['output'];
  documentId: Scalars['ObjectId']['output'];
  inspector?: Maybe<Contact>;
  inspectorId: Scalars['ObjectId']['output'];
  regulatoryAgency: Scalars['String']['output'];
  type: InspectionType;
};

export enum InspectionType {
  Final = 'final',
  Preliminary = 'preliminary'
}

export type InsuranceDocument = {
  __typename?: 'InsuranceDocument';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  allowedVisitPeople?: Maybe<Array<Contact>>;
  allowedVisitPeopleIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  archivedProposals?: Maybe<Array<Result>>;
  beneficiary?: Maybe<Contact>;
  beneficiaryId?: Maybe<Scalars['ObjectId']['output']>;
  claims?: Maybe<Array<Claim>>;
  commercialResponsible?: Maybe<User>;
  commercialResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  costNFFiles?: Maybe<Array<File>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  crop?: Maybe<Crop>;
  cropId: Scalars['ObjectId']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  farmer?: Maybe<Contact>;
  farmerId: Scalars['ObjectId']['output'];
  firstBillFile?: Maybe<File>;
  inspections?: Maybe<Array<Inspection>>;
  insuranceTypeGroup?: Maybe<InsuranceTypeGroupEnum>;
  justificationMessage?: Maybe<Scalars['String']['output']>;
  kmlFile?: Maybe<File>;
  operationalResponsible?: Maybe<User>;
  operationalResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  originator?: Maybe<User>;
  originatorId?: Maybe<Scalars['ObjectId']['output']>;
  paymentData?: Maybe<PaymentData>;
  payments?: Maybe<Array<Payment>>;
  policy?: Maybe<Policy>;
  policyId?: Maybe<Scalars['ObjectId']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  property?: Maybe<Property>;
  propertyId: Scalars['ObjectId']['output'];
  proposalFile?: Maybe<File>;
  proposalResult?: Maybe<Result>;
  proposalResultId?: Maybe<Scalars['ObjectId']['output']>;
  questions?: Maybe<CropInsuranceQuestions>;
  quotationDate?: Maybe<Scalars['Date']['output']>;
  selectedResultIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  selectedSimulationResults?: Maybe<Array<Maybe<Result>>>;
  simulationResults?: Maybe<Array<Maybe<Result>>>;
  stage?: Maybe<DocumentStages>;
  status?: Maybe<DocumentStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visitPerson?: Maybe<Contact>;
  visitPersonId?: Maybe<Scalars['ObjectId']['output']>;
};

export type InsuranceGroup = {
  __typename?: 'InsuranceGroup';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<InsuranceType>>>;
};

export type InsuranceType = {
  __typename?: 'InsuranceType';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  group?: Maybe<InsuranceGroup>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum InsuranceTypeGroupEnum {
  Agricultural = 'agricultural',
  Machinery = 'machinery'
}

export type Lead = {
  __typename?: 'Lead';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  area?: Maybe<Scalars['Float']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  commercialResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cultureIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  cultures?: Maybe<Array<Culture>>;
  email?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  meetingIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  meetings?: Maybe<Array<Meeting>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<RatingScale>;
  status?: Maybe<LeadStatus>;
  technicalResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  type?: Maybe<LeadTypes>;
};

export type LeadFiltersInput = {
  rating?: InputMaybe<RatingScale>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  type?: InputMaybe<LeadTypes>;
};

export enum LeadStatus {
  Deal = 'deal',
  New = 'new',
  Pitch = 'pitch',
  Refused = 'refused',
  Scrutiny = 'scrutiny'
}

export enum LeadTypes {
  Customer = 'customer',
  Partner = 'partner'
}

export enum LossEstimate {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type Meeting = {
  __typename?: 'Meeting';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  attachment?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date: Scalars['Date']['output'];
  responsible?: Maybe<User>;
  responsibleId: Scalars['ObjectId']['output'];
  status: MeetingStatus;
  topic: MeetingTopics;
};

export enum MeetingStatus {
  Done = 'done',
  Scheduled = 'scheduled'
}

export enum MeetingTopics {
  Followup = 'followup',
  Intro = 'intro',
  Quotation = 'quotation'
}

export type Mutation = {
  __typename?: 'Mutation';
  addCommentToLead: Scalars['Boolean']['output'];
  addCommentToUser: Scalars['Boolean']['output'];
  addCommercialResponsibleToDocument: Scalars['Boolean']['output'];
  addCommercialResponsibleToLead: Scalars['Boolean']['output'];
  addOperationalResponsibleToDocument: Scalars['Boolean']['output'];
  addOriginatorToDocument: Scalars['Boolean']['output'];
  addRatingToUser: Scalars['Boolean']['output'];
  addResponsibleToUser: Scalars['Boolean']['output'];
  addTechnicalResponsibleToLead: Scalars['Boolean']['output'];
  approveSimulationResult: Scalars['Boolean']['output'];
  archiveDocument: Scalars['Boolean']['output'];
  archiveProposal: Scalars['Boolean']['output'];
  changeLeadStatus: Scalars['Boolean']['output'];
  createFormResponse: FormResponse;
  createNote: Scalars['JSON']['output'];
  deletePayment: Scalars['Boolean']['output'];
  deleteSimulationResult: Scalars['Boolean']['output'];
  finishSimulation: Scalars['Boolean']['output'];
  rateLead: Scalars['Boolean']['output'];
  recedeDocumentStageToSimulation: Scalars['Boolean']['output'];
  redoQuotations: Scalars['Boolean']['output'];
  retrySimulationResult: Scalars['Boolean']['output'];
  selectResults: Scalars['Boolean']['output'];
  sendTransactionalEmail: Scalars['JSON']['output'];
  setDocumentAsSent: Scalars['Boolean']['output'];
  setPaymentDone: Scalars['Boolean']['output'];
  setQuotationComment: Scalars['Boolean']['output'];
  submitFormResponse: Scalars['JSON']['output'];
  upsertFormField: Array<Maybe<Scalars['JSON']['output']>>;
};


export type MutationAddCommentToLeadArgs = {
  comment: Scalars['String']['input'];
  leadId: Scalars['String']['input'];
};


export type MutationAddCommentToUserArgs = {
  comment: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddCommercialResponsibleToDocumentArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationAddCommercialResponsibleToLeadArgs = {
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
};


export type MutationAddOperationalResponsibleToDocumentArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationAddOriginatorToDocumentArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationAddRatingToUserArgs = {
  rating: RatingScale;
  userId: Scalars['String']['input'];
};


export type MutationAddResponsibleToUserArgs = {
  responsibleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddTechnicalResponsibleToLeadArgs = {
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
};


export type MutationApproveSimulationResultArgs = {
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
};


export type MutationArchiveDocumentArgs = {
  docId: Scalars['String']['input'];
};


export type MutationArchiveProposalArgs = {
  docId: Scalars['String']['input'];
};


export type MutationChangeLeadStatusArgs = {
  leadId: Scalars['String']['input'];
  status: LeadStatus;
};


export type MutationCreateFormResponseArgs = {
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
};


export type MutationCreateNoteArgs = {
  authorId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  serviceName: Services;
  text: Scalars['String']['input'];
};


export type MutationDeletePaymentArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationDeleteSimulationResultArgs = {
  resultId: Scalars['String']['input'];
};


export type MutationFinishSimulationArgs = {
  docId: Scalars['String']['input'];
};


export type MutationRateLeadArgs = {
  leadId: Scalars['String']['input'];
  rating: RatingScale;
};


export type MutationRecedeDocumentStageToSimulationArgs = {
  docId: Scalars['String']['input'];
  docStatus: DocumentStatus;
};


export type MutationRedoQuotationsArgs = {
  docId: Scalars['String']['input'];
};


export type MutationRetrySimulationResultArgs = {
  resultId: Scalars['String']['input'];
};


export type MutationSelectResultsArgs = {
  docId: Scalars['String']['input'];
  resultsIds: Array<Scalars['String']['input']>;
};


export type MutationSendTransactionalEmailArgs = {
  docId: Scalars['String']['input'];
  event: TransactionalEmailEvents;
};


export type MutationSetDocumentAsSentArgs = {
  docId: Scalars['String']['input'];
};


export type MutationSetPaymentDoneArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationSetQuotationCommentArgs = {
  docId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationSubmitFormResponseArgs = {
  formResponseId: Scalars['String']['input'];
};


export type MutationUpsertFormFieldArgs = {
  fieldPath: Scalars['String']['input'];
  formResponseId: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type Note = {
  __typename?: 'Note';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  authorId: User;
  createdAt?: Maybe<Scalars['Date']['output']>;
  documentId?: Maybe<Scalars['ObjectId']['output']>;
  serviceName?: Maybe<Services>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt: Scalars['Date']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  objectId: Scalars['ObjectId']['output'];
  originInfo: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  createdAt: Scalars['Date']['output'];
  data: Array<ObjectNotifications>;
};

export type ObjectNotifications = {
  __typename?: 'ObjectNotifications';
  data: Array<Notification>;
  notificationGroup: Scalars['ObjectId']['output'];
};

export type PartnersFiltersInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoles>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type Payment = {
  __typename?: 'Payment';
  _id: Scalars['ObjectId']['output'];
  amount: Scalars['Float']['output'];
  dateDue: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  provider: PropostaProviders;
  responsible?: Maybe<Contact>;
  responsibleId: Scalars['ObjectId']['output'];
  status: PaymentStatus;
  subventionType?: Maybe<SubventionType>;
};

export type PaymentData = {
  __typename?: 'PaymentData';
  accountData?: Maybe<AccountData>;
  installments?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<PaymentMethods>;
  responsible?: Maybe<Contact>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
};

export enum PaymentMethods {
  Boleto = 'boleto',
  Debit = 'debit'
}

export enum PaymentStatus {
  Deleted = 'deleted',
  Done = 'done',
  Pending = 'pending'
}

export type Plot = {
  __typename?: 'Plot';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropYear?: Maybe<Scalars['String']['output']>;
  cultureDetail?: Maybe<CultureDetail>;
  cultureDetailId?: Maybe<Scalars['ObjectId']['output']>;
  irrigated?: Maybe<Scalars['Boolean']['output']>;
  lineSpacing?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plantDate?: Maybe<Scalars['Date']['output']>;
  plantMethod?: Maybe<Scalars['String']['output']>;
  plantSpacing?: Maybe<Scalars['Float']['output']>;
  polygon?: Maybe<Array<Maybe<Scalars['LatLng']['output']>>>;
  property?: Maybe<Property>;
  soilType?: Maybe<Scalars['LabelAndCode']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Policy = {
  __typename?: 'Policy';
  _id: Scalars['ObjectId']['output'];
  billsFile?: Maybe<File>;
  documentId: Scalars['ObjectId']['output'];
  endDate: Scalars['Date']['output'];
  externalId: Scalars['String']['output'];
  farmerId: Scalars['ObjectId']['output'];
  insuranceTypeGroup: InsuranceTypeGroupEnum;
  policyFile: File;
  provider: PropostaProviders;
  startDate: Scalars['Date']['output'];
};

export type Property = {
  __typename?: 'Property';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  accessInstructions?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  entranceLocation?: Maybe<Scalars['LatLng']['output']>;
  kmlFile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Contact>;
  plots?: Maybe<Array<Maybe<Plot>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PropostaProviders {
  Agrobrasil = 'agrobrasil',
  Allianz = 'allianz',
  Btg = 'btg',
  Essor = 'essor',
  Fairfax = 'fairfax',
  Mapfre = 'mapfre',
  Porto = 'porto',
  Sancor = 'sancor',
  Sompo = 'sompo',
  Swiss = 'swiss',
  Tokyo = 'tokyo'
}

export type Query = {
  __typename?: 'Query';
  countDocuments?: Maybe<Scalars['Int']['output']>;
  countLeads?: Maybe<Scalars['Int']['output']>;
  countUsers?: Maybe<Scalars['Int']['output']>;
  document?: Maybe<InsuranceDocument>;
  documents?: Maybe<Array<Maybe<InsuranceDocument>>>;
  getComplementaryDataFormResponse: FormRequestResponse;
  getCreateClaimOnFormResponse: FormRequestResponse;
  getCreateInspectionOnFormResponse: FormRequestResponse;
  getCreateMeetingOnObjectFormResponse: FormRequestResponse;
  getCreateObjectFormResponse: Scalars['String']['output'];
  getCreatePaymentOnDocumentFormResponse: FormRequestResponse;
  getCreatePolicyOnDocumentFormResponse: FormRequestResponse;
  getCreateProposalOnDocumentFormResponse: FormRequestResponse;
  getCreateResultOnDocumentFormResponse: FormRequestResponse;
  getCreateSignedProposalOnFormResponse: FormRequestResponse;
  getEditClaimOnFormResponse: FormRequestResponse;
  getEditCropOnDocumentFormResponse: FormRequestResponse;
  getEditFarmerOnDocumentFormResponse: FormRequestResponse;
  getEditFinancialResponsibleOnDocumentFormResponse: FormRequestResponse;
  getEditInspectionOnFormResponse: FormRequestResponse;
  getEditLeadOnFormResponse: FormRequestResponse;
  getEditMeetingOnObjectFormResponse: FormRequestResponse;
  getEditObjectFormResponse: Scalars['String']['output'];
  getEditPaymentDataOnDocumentFormResponse: FormRequestResponse;
  getEditPaymentOnDocumentFormResponse: FormRequestResponse;
  getEditPolicyOnDocumentFormResponse: FormRequestResponse;
  getEditPropertyOnDocumentFormResponse: FormRequestResponse;
  getEditProposalOnDocumentFormResponse: FormRequestResponse;
  getEditResultOnDocumentFormResponse: FormRequestResponse;
  getEditSignedProposalOnFormResponse: FormRequestResponse;
  getFormResponse?: Maybe<FormResponse>;
  getMany2XOptions: Array<FormDataOptions>;
  getShareToken?: Maybe<Scalars['String']['output']>;
  inspection?: Maybe<Inspection>;
  lead?: Maybe<Lead>;
  leads?: Maybe<Array<Maybe<Lead>>>;
  modelTasks: Array<Task>;
  notes: Array<Note>;
  notifications: Array<NotificationResponse>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryCountDocumentsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
};


export type QueryCountLeadsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>>>>;
};


export type QueryCountUsersArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>>>>;
};


export type QueryDocumentArgs = {
  docId: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};


export type QueryGetComplementaryDataFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetCreateClaimOnFormResponseArgs = {
  payload: CreateClaimOnDocumentPayload;
};


export type QueryGetCreateInspectionOnFormResponseArgs = {
  payload: CreateInspectionOnDocumentPayload;
};


export type QueryGetCreateMeetingOnObjectFormResponseArgs = {
  payload: CreateMeetingOnObjectPayload;
};


export type QueryGetCreateObjectFormResponseArgs = {
  formId: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
  service: Services;
};


export type QueryGetCreatePaymentOnDocumentFormResponseArgs = {
  payload: CreatePaymentOnDocumentPayload;
};


export type QueryGetCreatePolicyOnDocumentFormResponseArgs = {
  payload: CreatePolicyOnDocumentPayload;
};


export type QueryGetCreateProposalOnDocumentFormResponseArgs = {
  payload: CreateProposalOnDocumentPayload;
};


export type QueryGetCreateResultOnDocumentFormResponseArgs = {
  payload: CreateResultOnDocumentPayload;
};


export type QueryGetCreateSignedProposalOnFormResponseArgs = {
  payload: CreateSignedProposalOnResultPayload;
};


export type QueryGetEditClaimOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditCropOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditFarmerOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditFinancialResponsibleOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditInspectionOnFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditLeadOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditMeetingOnObjectFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditObjectFormResponseArgs = {
  formId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  objectId: Scalars['String']['input'];
  service: Services;
};


export type QueryGetEditPaymentDataOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPaymentOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPolicyOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPropertyOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditProposalOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditResultOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditSignedProposalOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetFormResponseArgs = {
  formResponseId: Scalars['String']['input'];
};


export type QueryGetMany2XOptionsArgs = {
  currentValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain: Scalars['JSON']['input'];
  searchTerm: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryGetShareTokenArgs = {
  objectId: Scalars['String']['input'];
  service: Services;
};


export type QueryInspectionArgs = {
  inspectionId: Scalars['String']['input'];
};


export type QueryLeadArgs = {
  leadId: Scalars['String']['input'];
};


export type QueryLeadsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};


export type QueryModelTasksArgs = {
  objectId?: InputMaybe<Scalars['String']['input']>;
  serviceName: Services;
};


export type QueryNotesArgs = {
  docId: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryNotificationsArgs = {
  serviceName: Services;
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};

export enum RatingScale {
  Outstanding = 'outstanding',
  Poor = 'poor',
  Satisfactory = 'satisfactory',
  Unsatisfactory = 'unsatisfactory',
  VerySatisfactory = 'verySatisfactory'
}

export type Result = {
  __typename?: 'Result';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  amounts?: Maybe<ResultAmounts>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  basicCoverageType?: Maybe<BasicCoverageTypes>;
  coverages?: Maybe<Array<Maybe<ResultCoverage>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstBillFile?: Maybe<File>;
  guaranteedProductivity?: Maybe<Scalars['Float']['output']>;
  insuranceTypeGroup?: Maybe<InsuranceTypeGroupEnum>;
  name?: Maybe<Scalars['String']['output']>;
  proposalFile?: Maybe<File>;
  provider?: Maybe<PropostaProviders>;
  signedProposalFile?: Maybe<File>;
  status?: Maybe<ResultStatus>;
  type?: Maybe<ResultTypes>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ResultAmounts = {
  __typename?: 'ResultAmounts';
  federalSubvention?: Maybe<Scalars['Float']['output']>;
  finalPremium?: Maybe<Scalars['Float']['output']>;
  lmi?: Maybe<Scalars['Float']['output']>;
  maxPayments?: Maybe<Scalars['Int']['output']>;
  stateSubvention?: Maybe<Scalars['Float']['output']>;
  totalPremium?: Maybe<Scalars['Float']['output']>;
};

export type ResultCoverage = {
  __typename?: 'ResultCoverage';
  coverageTags?: Maybe<CoverageTags>;
  lmi?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
};

export enum ResultStatus {
  Approved = 'approved',
  Deleted = 'deleted',
  Error = 'error',
  Pending = 'pending',
  Sent = 'sent'
}

export enum ResultTypes {
  Proposal = 'proposal',
  Quotation = 'quotation',
  Simulation = 'simulation'
}

export enum Services {
  Calculations = 'calculations',
  Claims = 'claims',
  Contacts = 'contacts',
  Crops = 'crops',
  Cultures = 'cultures',
  Documents = 'documents',
  Email = 'email',
  EmissionInstitutions = 'emissionInstitutions',
  Forms = 'forms',
  Inspections = 'inspections',
  Leads = 'leads',
  Meetings = 'meetings',
  Notes = 'notes',
  Notifications = 'notifications',
  Payments = 'payments',
  Policies = 'policies',
  Professions = 'professions',
  Properties = 'properties',
  Results = 'results',
  Tasks = 'tasks',
  Users = 'users'
}

export enum SubventionType {
  Federal = 'federal',
  State = 'state'
}

export type Task = {
  __typename?: 'Task';
  dateDue: Scalars['Date']['output'];
  docId: Scalars['ObjectId']['output'];
  message: Scalars['String']['output'];
  modelName: Scalars['String']['output'];
  originInfo?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<User>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
};

export enum TransactionalEmailEvents {
  ApprovedQuotation = 'approvedQuotation',
  PendingQuotation = 'pendingQuotation',
  QuotationResults = 'quotationResults',
  UploadedPolicy = 'uploadedPolicy',
  UploadedProposal = 'uploadedProposal'
}

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  civilState?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Array<InsuranceDocument>>;
  email?: Maybe<Scalars['String']['output']>;
  indicators?: Maybe<Array<UserIndicator>>;
  meetingIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  meetings?: Maybe<Array<Meeting>>;
  nextCallDate?: Maybe<Scalars['Date']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<RatingScale>;
  responsible?: Maybe<User>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
  rg?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRoles>;
  signedDate?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserIndicator = {
  __typename?: 'UserIndicator';
  _id?: Maybe<Scalars['String']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  totalCommission?: Maybe<Scalars['Float']['output']>;
  totalPremium?: Maybe<Scalars['Float']['output']>;
};

export enum UserRating {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum UserRoles {
  Admin = 'admin',
  Consultant = 'consultant',
  Cooperative = 'cooperative',
  Organization = 'organization',
  Resale = 'resale'
}

export enum UserStatus {
  Active = 'active',
  Approved = 'approved',
  Registered = 'registered',
  Rejected = 'rejected'
}

export type SelectResultsMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SelectResultsMutation = { __typename?: 'Mutation', selectResults: boolean };

export type SetQuotationCommentMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SetQuotationCommentMutation = { __typename?: 'Mutation', setQuotationComment: boolean };

export type ApproveSimulationResultMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
}>;


export type ApproveSimulationResultMutation = { __typename?: 'Mutation', approveSimulationResult: boolean };

export type RecedeDocumentStageMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  docStatus: DocumentStatus;
}>;


export type RecedeDocumentStageMutation = { __typename?: 'Mutation', recedeDocumentStageToSimulation: boolean };

export type AddCommercialResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddCommercialResponsibleMutation = { __typename?: 'Mutation', addCommercialResponsibleToDocument: boolean };

export type AddOperationalResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddOperationalResponsibleMutation = { __typename?: 'Mutation', addOperationalResponsibleToDocument: boolean };

export type AddOriginatorMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  originatorId: Scalars['String']['input'];
}>;


export type AddOriginatorMutation = { __typename?: 'Mutation', addOriginatorToDocument: boolean };

export type ArchiveDocumentMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ArchiveDocumentMutation = { __typename?: 'Mutation', archiveDocument: boolean };

export type FinishSimulationMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type FinishSimulationMutation = { __typename?: 'Mutation', finishSimulation: boolean };

export type RedoQuotationsMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type RedoQuotationsMutation = { __typename?: 'Mutation', redoQuotations: boolean };

export type DeleteSimulationResultMutationVariables = Exact<{
  resultId: Scalars['String']['input'];
}>;


export type DeleteSimulationResultMutation = { __typename?: 'Mutation', deleteSimulationResult: boolean };

export type SetPaymentDoneMutationVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;


export type SetPaymentDoneMutation = { __typename?: 'Mutation', setPaymentDone: boolean };

export type SetDocumentAsSentMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type SetDocumentAsSentMutation = { __typename?: 'Mutation', setDocumentAsSent: boolean };

export type ArchiveProposalMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ArchiveProposalMutation = { __typename?: 'Mutation', archiveProposal: boolean };

export type DeletePaymentMutationVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: boolean };

export type CreateFormResponseMutationVariables = Exact<{
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type CreateFormResponseMutation = { __typename?: 'Mutation', createFormResponse: { __typename?: 'FormResponse', _id?: string | null } };

export type UpsertFormFieldMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}>;


export type UpsertFormFieldMutation = { __typename?: 'Mutation', upsertFormField: Array<any | null> };

export type SubmitFormResponseMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type SubmitFormResponseMutation = { __typename?: 'Mutation', submitFormResponse: any };

export type SendTransactionalEmailMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  event: TransactionalEmailEvents;
}>;


export type SendTransactionalEmailMutation = { __typename?: 'Mutation', sendTransactionalEmail: any };

export type AddCommercialResponsibleLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddCommercialResponsibleLeadMutation = { __typename?: 'Mutation', addCommercialResponsibleToLead: boolean };

export type AddTechnicalResponsibleLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddTechnicalResponsibleLeadMutation = { __typename?: 'Mutation', addTechnicalResponsibleToLead: boolean };

export type ChangeLeadStatusMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  status: LeadStatus;
}>;


export type ChangeLeadStatusMutation = { __typename?: 'Mutation', changeLeadStatus: boolean };

export type RateLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  rating: RatingScale;
}>;


export type RateLeadMutation = { __typename?: 'Mutation', rateLead: boolean };

export type AddCommentToLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type AddCommentToLeadMutation = { __typename?: 'Mutation', addCommentToLead: boolean };

export type CreateNoteMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  authorId: Scalars['String']['input'];
  serviceName: Services;
  text: Scalars['String']['input'];
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: any };

export type RetrySimulationResultMutationVariables = Exact<{
  resultId: Scalars['String']['input'];
}>;


export type RetrySimulationResultMutation = { __typename?: 'Mutation', retrySimulationResult: boolean };

export type AddResponsibleToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddResponsibleToUserMutation = { __typename?: 'Mutation', addResponsibleToUser: boolean };

export type AddRatingToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  rating: RatingScale;
}>;


export type AddRatingToUserMutation = { __typename?: 'Mutation', addRatingToUser: boolean };

export type AddCommentToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type AddCommentToUserMutation = { __typename?: 'Mutation', addCommentToUser: boolean };

export type GetCreateClaimOnFormResponseQueryVariables = Exact<{
  payload: CreateClaimOnDocumentPayload;
}>;


export type GetCreateClaimOnFormResponseQuery = { __typename?: 'Query', getCreateClaimOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditClaimOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditClaimOnFormResponseQuery = { __typename?: 'Query', getEditClaimOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditFarmerOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditFarmerOnDocumentFormResponseQuery = { __typename?: 'Query', getEditFarmerOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditFinancialResponsibleOnDocumentFormResponseQuery = { __typename?: 'Query', getEditFinancialResponsibleOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditCropOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditCropOnDocumentFormResponseQuery = { __typename?: 'Query', getEditCropOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ListDocumentsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
}>;


export type ListDocumentsQuery = { __typename?: 'Query', documents?: Array<{ __typename?: 'InsuranceDocument', _id?: string | null, stage?: DocumentStages | null, status?: DocumentStatus | null, createdAt?: any | null, commercialResponsibleId?: string | null, operationalResponsibleId?: string | null, originatorId?: string | null, commercialResponsible?: { __typename?: 'User', nome?: string | null } | null, operationalResponsible?: { __typename?: 'User', nome?: string | null } | null, originator?: { __typename?: 'User', nome?: string | null } | null, farmer?: { __typename?: 'Contact', name?: string | null } | null, crop?: { __typename?: 'Crop', cultureName?: string | null, area?: number | null, culture?: { __typename?: 'Culture', name?: string | null } | null } | null, property?: { __typename?: 'Property', address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null } | null } | null> | null };

export type CountDocumentsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
}>;


export type CountDocumentsQuery = { __typename?: 'Query', countDocuments?: number | null };

export type GetComplementaryDataFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetComplementaryDataFormResponseQuery = { __typename?: 'Query', getComplementaryDataFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPaymentDataOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPaymentDataOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPaymentDataOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetDocumentDetailsQueryVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type GetDocumentDetailsQuery = { __typename?: 'Query', document?: { __typename?: 'InsuranceDocument', _id?: string | null, createdAt?: any | null, updatedAt?: any | null, stage?: DocumentStages | null, status?: DocumentStatus | null, selectedResultIds?: Array<string> | null, justificationMessage?: string | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, commercialResponsibleId?: string | null, operationalResponsibleId?: string | null, originatorId?: string | null, premium?: number | null, archived?: boolean | null, proposalResultId?: string | null, visitPerson?: { __typename?: 'Contact', name?: string | null } | null, costNFFiles?: Array<{ __typename?: 'File', fileName?: string | null, fileKey?: string | null }> | null, kmlFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, firstBillFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, crop?: { __typename?: 'Crop', _id?: string | null, area?: number | null, cultureName?: string | null, harvestStartDate?: any | null, harvestEndDate?: any | null, manualCulture?: string | null, compositionType?: any | null, cropYear?: string | null, culture?: { __typename?: 'Culture', name?: string | null } | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null, kmlFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null }> | null } | null, farmer?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: string | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null, property?: { __typename?: 'Property', _id?: string | null, accessInstructions?: string | null, entranceLocation?: any | null, name?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null> | null } | null, simulationResults?: Array<{ __typename?: 'Result', _id?: string | null, externalId?: string | null, status?: ResultStatus | null, error?: string | null, name?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageTags?: CoverageTags | null } | null> | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null, maxPayments?: number | null } | null } | null> | null, selectedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageTags?: CoverageTags | null } | null> | null } | null> | null, proposalResult?: { __typename?: 'Result', _id?: string | null, externalId?: string | null, name?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, proposalFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, firstBillFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, signedProposalFile?: { __typename?: 'File', _id?: string | null, fileName?: string | null, fileKey?: string | null } | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageTags?: CoverageTags | null } | null> | null } | null, beneficiary?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: string | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null, allowedVisitPeople?: Array<{ __typename?: 'Contact', name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null }> | null, policy?: { __typename?: 'Policy', _id: string, endDate: any, startDate: any, externalId: string, billsFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, policyFile: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } } | null, paymentData?: { __typename?: 'PaymentData', method?: PaymentMethods | null, responsibleId?: string | null, installments?: number | null, accountData?: { __typename?: 'AccountData', bank?: string | null, agency?: string | null, account?: string | null } | null, responsible?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: string | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null } | null, payments?: Array<{ __typename?: 'Payment', _id: string, responsibleId: string, provider: PropostaProviders, name: string, dateDue: any, amount: number, status: PaymentStatus, subventionType?: SubventionType | null }> | null, archivedProposals?: Array<{ __typename?: 'Result', _id?: string | null, externalId?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, type?: ResultTypes | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, guaranteedProductivity?: number | null }> | null, claims?: Array<{ __typename?: 'Claim', _id: string, name: string, externalId: string, status: ClaimStatus, events: Array<ClaimEvent>, startDate: any, endDate: any, lossEstimate: LossEstimate, comment?: string | null, createdAt: any, plots?: Array<{ __typename?: 'Plot', _id?: string | null, name?: string | null, area?: number | null }> | null }> | null, inspections?: Array<{ __typename?: 'Inspection', _id: string, documentId: string, type: InspectionType, date: any, regulatoryAgency: string, claims?: Array<{ __typename?: 'Claim', name: string } | null> | null, inspector?: { __typename?: 'Contact', name?: string | null, mobilePhone?: string | null } | null }> | null } | null };

export type GetDirectDocumentDetailsQueryVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type GetDirectDocumentDetailsQuery = { __typename?: 'Query', document?: { __typename?: 'InsuranceDocument', _id?: string | null, stage?: DocumentStages | null, status?: DocumentStatus | null, justificationMessage?: string | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, premium?: number | null, createdAt?: any | null, crop?: { __typename?: 'Crop', area?: number | null, cultureName?: string | null, manualCulture?: string | null, culture?: { __typename?: 'Culture', name?: string | null } | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null, farmer?: { __typename?: 'Contact', name?: string | null, cpfCnpj?: string | null } | null, property?: { __typename?: 'Property', name?: string | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null> | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null } | null, selectedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageTags?: CoverageTags | null } | null> | null } | null> | null } | null };

export type GetFormResponseQueryVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type GetFormResponseQuery = { __typename?: 'Query', getFormResponse?: { __typename?: 'FormResponse', formData?: any | null, formState?: any | null, errors?: any | null } | null };

export type GetCreateObjectFormResponseQueryVariables = Exact<{
  service: Services;
  formId: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;


export type GetCreateObjectFormResponseQuery = { __typename?: 'Query', getCreateObjectFormResponse: string };

export type GetEditObjectFormResponseQueryVariables = Exact<{
  service: Services;
  formId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetEditObjectFormResponseQuery = { __typename?: 'Query', getEditObjectFormResponse: string };

export type GetShareTokenQueryVariables = Exact<{
  service: Services;
  objectId: Scalars['String']['input'];
}>;


export type GetShareTokenQuery = { __typename?: 'Query', getShareToken?: string | null };

export type GetMany2XOptionsQueryVariables = Exact<{
  serviceName: Services;
  domain: Scalars['JSON']['input'];
  searchTerm: Scalars['String']['input'];
  currentValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetMany2XOptionsQuery = { __typename?: 'Query', getMany2XOptions: Array<{ __typename?: 'FormDataOptions', label?: string | null, value: string }> };

export type GetCreateInspectionOnFormResponseQueryVariables = Exact<{
  payload: CreateInspectionOnDocumentPayload;
}>;


export type GetCreateInspectionOnFormResponseQuery = { __typename?: 'Query', getCreateInspectionOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditInspectionOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditInspectionOnFormResponseQuery = { __typename?: 'Query', getEditInspectionOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ListLeadsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>> | InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>;
}>;


export type ListLeadsQuery = { __typename?: 'Query', leads?: Array<{ __typename?: 'Lead', _id?: string | null, area?: number | null, type?: LeadTypes | null, status?: LeadStatus | null, name?: string | null, createdAt?: any | null, rating?: RatingScale | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, cep?: string | null } | null, cultures?: Array<{ __typename?: 'Culture', _id?: string | null, name?: string | null }> | null } | null> | null };

export type CountLeadsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>> | InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>;
}>;


export type CountLeadsQuery = { __typename?: 'Query', countLeads?: number | null };

export type GetLeadDetailsQueryVariables = Exact<{
  leadId: Scalars['String']['input'];
}>;


export type GetLeadDetailsQuery = { __typename?: 'Query', lead?: { __typename?: 'Lead', _id?: string | null, type?: LeadTypes | null, status?: LeadStatus | null, name?: string | null, area?: number | null, comments?: string | null, createdAt?: any | null, email?: string | null, linkedin?: string | null, meetingIds?: Array<string> | null, phone?: string | null, rating?: RatingScale | null, commercialResponsibleId?: string | null, technicalResponsibleId?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null } | null, cultures?: Array<{ __typename?: 'Culture', _id?: string | null, name?: string | null }> | null, meetings?: Array<{ __typename?: 'Meeting', _id?: string | null, status: MeetingStatus, date: any, topic: MeetingTopics, comment?: string | null, attachment?: any | null, responsible?: { __typename?: 'User', nome?: string | null } | null }> | null } | null };

export type GetEditLeadOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditLeadOnFormResponseQuery = { __typename?: 'Query', getEditLeadOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateMeetingOnObjectFormResponseQueryVariables = Exact<{
  payload: CreateMeetingOnObjectPayload;
}>;


export type GetCreateMeetingOnObjectFormResponseQuery = { __typename?: 'Query', getCreateMeetingOnObjectFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditMeetingOnObjectFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditMeetingOnObjectFormResponseQuery = { __typename?: 'Query', getEditMeetingOnObjectFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type NotesQueryVariables = Exact<{
  docId: Scalars['String']['input'];
  serviceName: Services;
}>;


export type NotesQuery = { __typename?: 'Query', notes: Array<{ __typename?: 'Note', text?: string | null, createdAt?: any | null, serviceName?: Services | null, authorId: { __typename?: 'User', nome?: string | null } }> };

export type NotificationsQueryVariables = Exact<{
  serviceName: Services;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'NotificationResponse', createdAt: any, data: Array<{ __typename?: 'ObjectNotifications', notificationGroup: string, data: Array<{ __typename?: 'Notification', objectId: string, serviceName: string, createdAt: any, text: string, originInfo: string, author?: { __typename?: 'User', nome?: string | null } | null }> }> }> };

export type GetCreatePaymentOnDocumentFormResponseQueryVariables = Exact<{
  payload: CreatePaymentOnDocumentPayload;
}>;


export type GetCreatePaymentOnDocumentFormResponseQuery = { __typename?: 'Query', getCreatePaymentOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPaymentOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPaymentOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPaymentOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreatePolicyOnDocumentFormResponseQueryVariables = Exact<{
  payload: CreatePolicyOnDocumentPayload;
}>;


export type GetCreatePolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getCreatePolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPolicyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPropertyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditPropertyOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPropertyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateProposalOnDocumentFormResponseQueryVariables = Exact<{
  payload: CreateProposalOnDocumentPayload;
}>;


export type GetCreateProposalOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateProposalOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateResultOnDocumentFormResponseQueryVariables = Exact<{
  payload: CreateResultOnDocumentPayload;
}>;


export type GetCreateResultOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateResultOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditProposalOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditProposalOnDocumentFormResponseQuery = { __typename?: 'Query', getEditProposalOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditResultOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditResultOnDocumentFormResponseQuery = { __typename?: 'Query', getEditResultOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateSignedProposalOnFormResponseQueryVariables = Exact<{
  payload: CreateSignedProposalOnResultPayload;
}>;


export type GetCreateSignedProposalOnFormResponseQuery = { __typename?: 'Query', getCreateSignedProposalOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditSignedProposalOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditSignedProposalOnFormResponseQuery = { __typename?: 'Query', getEditSignedProposalOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ModelTasksQueryVariables = Exact<{
  serviceName: Services;
  objectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ModelTasksQuery = { __typename?: 'Query', modelTasks: Array<{ __typename?: 'Task', modelName: string, message: string, docId: string, dateDue: any, originInfo?: string | null, responsible?: { __typename?: 'User', nome?: string | null } | null }> };

export type ListUsersQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>> | InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>;
}>;


export type ListUsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', _id?: string | null, role?: UserRoles | null, status?: UserStatus | null, nome?: string | null, email?: string | null, city?: string | null, state?: string | null, disabled?: boolean | null, profession?: string | null, signedDate?: any | null, responsibleId?: string | null, createdAt?: any | null } | null> | null };

export type CountUsersQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>> | InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>;
}>;


export type CountUsersQuery = { __typename?: 'Query', countUsers?: number | null };

export type GetUserDetailsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserDetailsQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, role?: UserRoles | null, status?: UserStatus | null, signedDate?: any | null, createdAt?: any | null, disabled?: boolean | null, username?: string | null, nome?: string | null, email?: string | null, phone?: string | null, cpf?: string | null, rg?: string | null, civilState?: string | null, cep?: string | null, city?: string | null, state?: string | null, profession?: string | null, rating?: RatingScale | null, comments?: string | null, responsible?: { __typename?: 'User', _id?: string | null, nome?: string | null } | null, meetings?: Array<{ __typename?: 'Meeting', _id?: string | null, status: MeetingStatus, responsibleId: string, date: any, topic: MeetingTopics, comment?: string | null, attachment?: any | null, responsible?: { __typename?: 'User', nome?: string | null } | null }> | null, indicators?: Array<{ __typename?: 'UserIndicator', _id?: string | null, totalArea?: number | null, totalPremium?: number | null, totalCommission?: number | null }> | null } | null };

export type GetUserIndicatorsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserIndicatorsQuery = { __typename?: 'Query', user?: { __typename?: 'User', indicators?: Array<{ __typename?: 'UserIndicator', _id?: string | null, totalArea?: number | null, totalPremium?: number | null, totalCommission?: number | null }> | null } | null };


export const SelectResultsDocument = gql`
    mutation SelectResults($docId: String!, $resultsIds: [String!]!) {
  selectResults(docId: $docId, resultsIds: $resultsIds)
}
    `;
export type SelectResultsMutationFn = Apollo.MutationFunction<SelectResultsMutation, SelectResultsMutationVariables>;

/**
 * __useSelectResultsMutation__
 *
 * To run a mutation, you first call `useSelectResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectResultsMutation, { data, loading, error }] = useSelectResultsMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultsIds: // value for 'resultsIds'
 *   },
 * });
 */
export function useSelectResultsMutation(baseOptions?: Apollo.MutationHookOptions<SelectResultsMutation, SelectResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectResultsMutation, SelectResultsMutationVariables>(SelectResultsDocument, options);
      }
export type SelectResultsMutationHookResult = ReturnType<typeof useSelectResultsMutation>;
export type SelectResultsMutationResult = Apollo.MutationResult<SelectResultsMutation>;
export type SelectResultsMutationOptions = Apollo.BaseMutationOptions<SelectResultsMutation, SelectResultsMutationVariables>;
export const SetQuotationCommentDocument = gql`
    mutation SetQuotationComment($docId: String!, $message: String!) {
  setQuotationComment(docId: $docId, message: $message)
}
    `;
export type SetQuotationCommentMutationFn = Apollo.MutationFunction<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>;

/**
 * __useSetQuotationCommentMutation__
 *
 * To run a mutation, you first call `useSetQuotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuotationCommentMutation, { data, loading, error }] = useSetQuotationCommentMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSetQuotationCommentMutation(baseOptions?: Apollo.MutationHookOptions<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>(SetQuotationCommentDocument, options);
      }
export type SetQuotationCommentMutationHookResult = ReturnType<typeof useSetQuotationCommentMutation>;
export type SetQuotationCommentMutationResult = Apollo.MutationResult<SetQuotationCommentMutation>;
export type SetQuotationCommentMutationOptions = Apollo.BaseMutationOptions<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>;
export const ApproveSimulationResultDocument = gql`
    mutation ApproveSimulationResult($docId: String!, $resultId: String!) {
  approveSimulationResult(docId: $docId, resultId: $resultId)
}
    `;
export type ApproveSimulationResultMutationFn = Apollo.MutationFunction<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>;

/**
 * __useApproveSimulationResultMutation__
 *
 * To run a mutation, you first call `useApproveSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSimulationResultMutation, { data, loading, error }] = useApproveSimulationResultMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useApproveSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>(ApproveSimulationResultDocument, options);
      }
export type ApproveSimulationResultMutationHookResult = ReturnType<typeof useApproveSimulationResultMutation>;
export type ApproveSimulationResultMutationResult = Apollo.MutationResult<ApproveSimulationResultMutation>;
export type ApproveSimulationResultMutationOptions = Apollo.BaseMutationOptions<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>;
export const RecedeDocumentStageDocument = gql`
    mutation RecedeDocumentStage($docId: String!, $docStatus: DocumentStatus!) {
  recedeDocumentStageToSimulation(docId: $docId, docStatus: $docStatus)
}
    `;
export type RecedeDocumentStageMutationFn = Apollo.MutationFunction<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>;

/**
 * __useRecedeDocumentStageMutation__
 *
 * To run a mutation, you first call `useRecedeDocumentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecedeDocumentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recedeDocumentStageMutation, { data, loading, error }] = useRecedeDocumentStageMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      docStatus: // value for 'docStatus'
 *   },
 * });
 */
export function useRecedeDocumentStageMutation(baseOptions?: Apollo.MutationHookOptions<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>(RecedeDocumentStageDocument, options);
      }
export type RecedeDocumentStageMutationHookResult = ReturnType<typeof useRecedeDocumentStageMutation>;
export type RecedeDocumentStageMutationResult = Apollo.MutationResult<RecedeDocumentStageMutation>;
export type RecedeDocumentStageMutationOptions = Apollo.BaseMutationOptions<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>;
export const AddCommercialResponsibleDocument = gql`
    mutation addCommercialResponsible($docId: String!, $responsibleId: String!) {
  addCommercialResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type AddCommercialResponsibleMutationFn = Apollo.MutationFunction<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>;

/**
 * __useAddCommercialResponsibleMutation__
 *
 * To run a mutation, you first call `useAddCommercialResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommercialResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommercialResponsibleMutation, { data, loading, error }] = useAddCommercialResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddCommercialResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>(AddCommercialResponsibleDocument, options);
      }
export type AddCommercialResponsibleMutationHookResult = ReturnType<typeof useAddCommercialResponsibleMutation>;
export type AddCommercialResponsibleMutationResult = Apollo.MutationResult<AddCommercialResponsibleMutation>;
export type AddCommercialResponsibleMutationOptions = Apollo.BaseMutationOptions<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>;
export const AddOperationalResponsibleDocument = gql`
    mutation addOperationalResponsible($docId: String!, $responsibleId: String!) {
  addOperationalResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type AddOperationalResponsibleMutationFn = Apollo.MutationFunction<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>;

/**
 * __useAddOperationalResponsibleMutation__
 *
 * To run a mutation, you first call `useAddOperationalResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOperationalResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOperationalResponsibleMutation, { data, loading, error }] = useAddOperationalResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddOperationalResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>(AddOperationalResponsibleDocument, options);
      }
export type AddOperationalResponsibleMutationHookResult = ReturnType<typeof useAddOperationalResponsibleMutation>;
export type AddOperationalResponsibleMutationResult = Apollo.MutationResult<AddOperationalResponsibleMutation>;
export type AddOperationalResponsibleMutationOptions = Apollo.BaseMutationOptions<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>;
export const AddOriginatorDocument = gql`
    mutation addOriginator($docId: String!, $originatorId: String!) {
  addOriginatorToDocument(docId: $docId, contactId: $originatorId)
}
    `;
export type AddOriginatorMutationFn = Apollo.MutationFunction<AddOriginatorMutation, AddOriginatorMutationVariables>;

/**
 * __useAddOriginatorMutation__
 *
 * To run a mutation, you first call `useAddOriginatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOriginatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOriginatorMutation, { data, loading, error }] = useAddOriginatorMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      originatorId: // value for 'originatorId'
 *   },
 * });
 */
export function useAddOriginatorMutation(baseOptions?: Apollo.MutationHookOptions<AddOriginatorMutation, AddOriginatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOriginatorMutation, AddOriginatorMutationVariables>(AddOriginatorDocument, options);
      }
export type AddOriginatorMutationHookResult = ReturnType<typeof useAddOriginatorMutation>;
export type AddOriginatorMutationResult = Apollo.MutationResult<AddOriginatorMutation>;
export type AddOriginatorMutationOptions = Apollo.BaseMutationOptions<AddOriginatorMutation, AddOriginatorMutationVariables>;
export const ArchiveDocumentDocument = gql`
    mutation archiveDocument($docId: String!) {
  archiveDocument(docId: $docId)
}
    `;
export type ArchiveDocumentMutationFn = Apollo.MutationFunction<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;

/**
 * __useArchiveDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDocumentMutation, { data, loading, error }] = useArchiveDocumentMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useArchiveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>(ArchiveDocumentDocument, options);
      }
export type ArchiveDocumentMutationHookResult = ReturnType<typeof useArchiveDocumentMutation>;
export type ArchiveDocumentMutationResult = Apollo.MutationResult<ArchiveDocumentMutation>;
export type ArchiveDocumentMutationOptions = Apollo.BaseMutationOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;
export const FinishSimulationDocument = gql`
    mutation finishSimulation($docId: String!) {
  finishSimulation(docId: $docId)
}
    `;
export type FinishSimulationMutationFn = Apollo.MutationFunction<FinishSimulationMutation, FinishSimulationMutationVariables>;

/**
 * __useFinishSimulationMutation__
 *
 * To run a mutation, you first call `useFinishSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSimulationMutation, { data, loading, error }] = useFinishSimulationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useFinishSimulationMutation(baseOptions?: Apollo.MutationHookOptions<FinishSimulationMutation, FinishSimulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSimulationMutation, FinishSimulationMutationVariables>(FinishSimulationDocument, options);
      }
export type FinishSimulationMutationHookResult = ReturnType<typeof useFinishSimulationMutation>;
export type FinishSimulationMutationResult = Apollo.MutationResult<FinishSimulationMutation>;
export type FinishSimulationMutationOptions = Apollo.BaseMutationOptions<FinishSimulationMutation, FinishSimulationMutationVariables>;
export const RedoQuotationsDocument = gql`
    mutation RedoQuotations($docId: String!) {
  redoQuotations(docId: $docId)
}
    `;
export type RedoQuotationsMutationFn = Apollo.MutationFunction<RedoQuotationsMutation, RedoQuotationsMutationVariables>;

/**
 * __useRedoQuotationsMutation__
 *
 * To run a mutation, you first call `useRedoQuotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedoQuotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redoQuotationsMutation, { data, loading, error }] = useRedoQuotationsMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useRedoQuotationsMutation(baseOptions?: Apollo.MutationHookOptions<RedoQuotationsMutation, RedoQuotationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedoQuotationsMutation, RedoQuotationsMutationVariables>(RedoQuotationsDocument, options);
      }
export type RedoQuotationsMutationHookResult = ReturnType<typeof useRedoQuotationsMutation>;
export type RedoQuotationsMutationResult = Apollo.MutationResult<RedoQuotationsMutation>;
export type RedoQuotationsMutationOptions = Apollo.BaseMutationOptions<RedoQuotationsMutation, RedoQuotationsMutationVariables>;
export const DeleteSimulationResultDocument = gql`
    mutation DeleteSimulationResult($resultId: String!) {
  deleteSimulationResult(resultId: $resultId)
}
    `;
export type DeleteSimulationResultMutationFn = Apollo.MutationFunction<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>;

/**
 * __useDeleteSimulationResultMutation__
 *
 * To run a mutation, you first call `useDeleteSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSimulationResultMutation, { data, loading, error }] = useDeleteSimulationResultMutation({
 *   variables: {
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useDeleteSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>(DeleteSimulationResultDocument, options);
      }
export type DeleteSimulationResultMutationHookResult = ReturnType<typeof useDeleteSimulationResultMutation>;
export type DeleteSimulationResultMutationResult = Apollo.MutationResult<DeleteSimulationResultMutation>;
export type DeleteSimulationResultMutationOptions = Apollo.BaseMutationOptions<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>;
export const SetPaymentDoneDocument = gql`
    mutation SetPaymentDone($paymentId: String!) {
  setPaymentDone(paymentId: $paymentId)
}
    `;
export type SetPaymentDoneMutationFn = Apollo.MutationFunction<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>;

/**
 * __useSetPaymentDoneMutation__
 *
 * To run a mutation, you first call `useSetPaymentDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentDoneMutation, { data, loading, error }] = useSetPaymentDoneMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useSetPaymentDoneMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>(SetPaymentDoneDocument, options);
      }
export type SetPaymentDoneMutationHookResult = ReturnType<typeof useSetPaymentDoneMutation>;
export type SetPaymentDoneMutationResult = Apollo.MutationResult<SetPaymentDoneMutation>;
export type SetPaymentDoneMutationOptions = Apollo.BaseMutationOptions<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>;
export const SetDocumentAsSentDocument = gql`
    mutation SetDocumentAsSent($docId: String!) {
  setDocumentAsSent(docId: $docId)
}
    `;
export type SetDocumentAsSentMutationFn = Apollo.MutationFunction<SetDocumentAsSentMutation, SetDocumentAsSentMutationVariables>;

/**
 * __useSetDocumentAsSentMutation__
 *
 * To run a mutation, you first call `useSetDocumentAsSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentAsSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentAsSentMutation, { data, loading, error }] = useSetDocumentAsSentMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useSetDocumentAsSentMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentAsSentMutation, SetDocumentAsSentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentAsSentMutation, SetDocumentAsSentMutationVariables>(SetDocumentAsSentDocument, options);
      }
export type SetDocumentAsSentMutationHookResult = ReturnType<typeof useSetDocumentAsSentMutation>;
export type SetDocumentAsSentMutationResult = Apollo.MutationResult<SetDocumentAsSentMutation>;
export type SetDocumentAsSentMutationOptions = Apollo.BaseMutationOptions<SetDocumentAsSentMutation, SetDocumentAsSentMutationVariables>;
export const ArchiveProposalDocument = gql`
    mutation archiveProposal($docId: String!) {
  archiveProposal(docId: $docId)
}
    `;
export type ArchiveProposalMutationFn = Apollo.MutationFunction<ArchiveProposalMutation, ArchiveProposalMutationVariables>;

/**
 * __useArchiveProposalMutation__
 *
 * To run a mutation, you first call `useArchiveProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProposalMutation, { data, loading, error }] = useArchiveProposalMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useArchiveProposalMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProposalMutation, ArchiveProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProposalMutation, ArchiveProposalMutationVariables>(ArchiveProposalDocument, options);
      }
export type ArchiveProposalMutationHookResult = ReturnType<typeof useArchiveProposalMutation>;
export type ArchiveProposalMutationResult = Apollo.MutationResult<ArchiveProposalMutation>;
export type ArchiveProposalMutationOptions = Apollo.BaseMutationOptions<ArchiveProposalMutation, ArchiveProposalMutationVariables>;
export const DeletePaymentDocument = gql`
    mutation DeletePayment($paymentId: String!) {
  deletePayment(paymentId: $paymentId)
}
    `;
export type DeletePaymentMutationFn = Apollo.MutationFunction<DeletePaymentMutation, DeletePaymentMutationVariables>;

/**
 * __useDeletePaymentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMutation, { data, loading, error }] = useDeletePaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDeletePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMutation, DeletePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMutation, DeletePaymentMutationVariables>(DeletePaymentDocument, options);
      }
export type DeletePaymentMutationHookResult = ReturnType<typeof useDeletePaymentMutation>;
export type DeletePaymentMutationResult = Apollo.MutationResult<DeletePaymentMutation>;
export type DeletePaymentMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const CreateFormResponseDocument = gql`
    mutation CreateFormResponse($formId: String!, $metadata: JSON!) {
  createFormResponse(formId: $formId, metadata: $metadata) {
    _id
  }
}
    `;
export type CreateFormResponseMutationFn = Apollo.MutationFunction<CreateFormResponseMutation, CreateFormResponseMutationVariables>;

/**
 * __useCreateFormResponseMutation__
 *
 * To run a mutation, you first call `useCreateFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormResponseMutation, { data, loading, error }] = useCreateFormResponseMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormResponseMutation, CreateFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormResponseMutation, CreateFormResponseMutationVariables>(CreateFormResponseDocument, options);
      }
export type CreateFormResponseMutationHookResult = ReturnType<typeof useCreateFormResponseMutation>;
export type CreateFormResponseMutationResult = Apollo.MutationResult<CreateFormResponseMutation>;
export type CreateFormResponseMutationOptions = Apollo.BaseMutationOptions<CreateFormResponseMutation, CreateFormResponseMutationVariables>;
export const UpsertFormFieldDocument = gql`
    mutation UpsertFormField($formResponseId: String!, $fieldPath: String!, $value: JSON!) {
  upsertFormField(
    formResponseId: $formResponseId
    fieldPath: $fieldPath
    value: $value
  )
}
    `;
export type UpsertFormFieldMutationFn = Apollo.MutationFunction<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>;

/**
 * __useUpsertFormFieldMutation__
 *
 * To run a mutation, you first call `useUpsertFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFormFieldMutation, { data, loading, error }] = useUpsertFormFieldMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *      fieldPath: // value for 'fieldPath'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertFormFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>(UpsertFormFieldDocument, options);
      }
export type UpsertFormFieldMutationHookResult = ReturnType<typeof useUpsertFormFieldMutation>;
export type UpsertFormFieldMutationResult = Apollo.MutationResult<UpsertFormFieldMutation>;
export type UpsertFormFieldMutationOptions = Apollo.BaseMutationOptions<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>;
export const SubmitFormResponseDocument = gql`
    mutation SubmitFormResponse($formResponseId: String!) {
  submitFormResponse(formResponseId: $formResponseId)
}
    `;
export type SubmitFormResponseMutationFn = Apollo.MutationFunction<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>;

/**
 * __useSubmitFormResponseMutation__
 *
 * To run a mutation, you first call `useSubmitFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResponseMutation, { data, loading, error }] = useSubmitFormResponseMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useSubmitFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>(SubmitFormResponseDocument, options);
      }
export type SubmitFormResponseMutationHookResult = ReturnType<typeof useSubmitFormResponseMutation>;
export type SubmitFormResponseMutationResult = Apollo.MutationResult<SubmitFormResponseMutation>;
export type SubmitFormResponseMutationOptions = Apollo.BaseMutationOptions<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>;
export const SendTransactionalEmailDocument = gql`
    mutation SendTransactionalEmail($docId: String!, $event: TransactionalEmailEvents!) {
  sendTransactionalEmail(docId: $docId, event: $event)
}
    `;
export type SendTransactionalEmailMutationFn = Apollo.MutationFunction<SendTransactionalEmailMutation, SendTransactionalEmailMutationVariables>;

/**
 * __useSendTransactionalEmailMutation__
 *
 * To run a mutation, you first call `useSendTransactionalEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTransactionalEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTransactionalEmailMutation, { data, loading, error }] = useSendTransactionalEmailMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useSendTransactionalEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTransactionalEmailMutation, SendTransactionalEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTransactionalEmailMutation, SendTransactionalEmailMutationVariables>(SendTransactionalEmailDocument, options);
      }
export type SendTransactionalEmailMutationHookResult = ReturnType<typeof useSendTransactionalEmailMutation>;
export type SendTransactionalEmailMutationResult = Apollo.MutationResult<SendTransactionalEmailMutation>;
export type SendTransactionalEmailMutationOptions = Apollo.BaseMutationOptions<SendTransactionalEmailMutation, SendTransactionalEmailMutationVariables>;
export const AddCommercialResponsibleLeadDocument = gql`
    mutation addCommercialResponsibleLead($leadId: String!, $responsibleId: String!) {
  addCommercialResponsibleToLead(leadId: $leadId, responsibleId: $responsibleId)
}
    `;
export type AddCommercialResponsibleLeadMutationFn = Apollo.MutationFunction<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>;

/**
 * __useAddCommercialResponsibleLeadMutation__
 *
 * To run a mutation, you first call `useAddCommercialResponsibleLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommercialResponsibleLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommercialResponsibleLeadMutation, { data, loading, error }] = useAddCommercialResponsibleLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddCommercialResponsibleLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>(AddCommercialResponsibleLeadDocument, options);
      }
export type AddCommercialResponsibleLeadMutationHookResult = ReturnType<typeof useAddCommercialResponsibleLeadMutation>;
export type AddCommercialResponsibleLeadMutationResult = Apollo.MutationResult<AddCommercialResponsibleLeadMutation>;
export type AddCommercialResponsibleLeadMutationOptions = Apollo.BaseMutationOptions<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>;
export const AddTechnicalResponsibleLeadDocument = gql`
    mutation addTechnicalResponsibleLead($leadId: String!, $responsibleId: String!) {
  addTechnicalResponsibleToLead(leadId: $leadId, responsibleId: $responsibleId)
}
    `;
export type AddTechnicalResponsibleLeadMutationFn = Apollo.MutationFunction<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>;

/**
 * __useAddTechnicalResponsibleLeadMutation__
 *
 * To run a mutation, you first call `useAddTechnicalResponsibleLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTechnicalResponsibleLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTechnicalResponsibleLeadMutation, { data, loading, error }] = useAddTechnicalResponsibleLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddTechnicalResponsibleLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>(AddTechnicalResponsibleLeadDocument, options);
      }
export type AddTechnicalResponsibleLeadMutationHookResult = ReturnType<typeof useAddTechnicalResponsibleLeadMutation>;
export type AddTechnicalResponsibleLeadMutationResult = Apollo.MutationResult<AddTechnicalResponsibleLeadMutation>;
export type AddTechnicalResponsibleLeadMutationOptions = Apollo.BaseMutationOptions<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>;
export const ChangeLeadStatusDocument = gql`
    mutation changeLeadStatus($leadId: String!, $status: LeadStatus!) {
  changeLeadStatus(leadId: $leadId, status: $status)
}
    `;
export type ChangeLeadStatusMutationFn = Apollo.MutationFunction<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;

/**
 * __useChangeLeadStatusMutation__
 *
 * To run a mutation, you first call `useChangeLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLeadStatusMutation, { data, loading, error }] = useChangeLeadStatusMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>(ChangeLeadStatusDocument, options);
      }
export type ChangeLeadStatusMutationHookResult = ReturnType<typeof useChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationResult = Apollo.MutationResult<ChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationOptions = Apollo.BaseMutationOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;
export const RateLeadDocument = gql`
    mutation rateLead($leadId: String!, $rating: RatingScale!) {
  rateLead(leadId: $leadId, rating: $rating)
}
    `;
export type RateLeadMutationFn = Apollo.MutationFunction<RateLeadMutation, RateLeadMutationVariables>;

/**
 * __useRateLeadMutation__
 *
 * To run a mutation, you first call `useRateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateLeadMutation, { data, loading, error }] = useRateLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useRateLeadMutation(baseOptions?: Apollo.MutationHookOptions<RateLeadMutation, RateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateLeadMutation, RateLeadMutationVariables>(RateLeadDocument, options);
      }
export type RateLeadMutationHookResult = ReturnType<typeof useRateLeadMutation>;
export type RateLeadMutationResult = Apollo.MutationResult<RateLeadMutation>;
export type RateLeadMutationOptions = Apollo.BaseMutationOptions<RateLeadMutation, RateLeadMutationVariables>;
export const AddCommentToLeadDocument = gql`
    mutation addCommentToLead($leadId: String!, $comment: String!) {
  addCommentToLead(leadId: $leadId, comment: $comment)
}
    `;
export type AddCommentToLeadMutationFn = Apollo.MutationFunction<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>;

/**
 * __useAddCommentToLeadMutation__
 *
 * To run a mutation, you first call `useAddCommentToLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentToLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentToLeadMutation, { data, loading, error }] = useAddCommentToLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentToLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>(AddCommentToLeadDocument, options);
      }
export type AddCommentToLeadMutationHookResult = ReturnType<typeof useAddCommentToLeadMutation>;
export type AddCommentToLeadMutationResult = Apollo.MutationResult<AddCommentToLeadMutation>;
export type AddCommentToLeadMutationOptions = Apollo.BaseMutationOptions<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($docId: String!, $authorId: String!, $serviceName: Services!, $text: String!) {
  createNote(
    docId: $docId
    authorId: $authorId
    serviceName: $serviceName
    text: $text
  )
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      authorId: // value for 'authorId'
 *      serviceName: // value for 'serviceName'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const RetrySimulationResultDocument = gql`
    mutation RetrySimulationResult($resultId: String!) {
  retrySimulationResult(resultId: $resultId)
}
    `;
export type RetrySimulationResultMutationFn = Apollo.MutationFunction<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>;

/**
 * __useRetrySimulationResultMutation__
 *
 * To run a mutation, you first call `useRetrySimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySimulationResultMutation, { data, loading, error }] = useRetrySimulationResultMutation({
 *   variables: {
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useRetrySimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>(RetrySimulationResultDocument, options);
      }
export type RetrySimulationResultMutationHookResult = ReturnType<typeof useRetrySimulationResultMutation>;
export type RetrySimulationResultMutationResult = Apollo.MutationResult<RetrySimulationResultMutation>;
export type RetrySimulationResultMutationOptions = Apollo.BaseMutationOptions<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>;
export const AddResponsibleToUserDocument = gql`
    mutation AddResponsibleToUser($userId: String!, $responsibleId: String!) {
  addResponsibleToUser(userId: $userId, responsibleId: $responsibleId)
}
    `;
export type AddResponsibleToUserMutationFn = Apollo.MutationFunction<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>;

/**
 * __useAddResponsibleToUserMutation__
 *
 * To run a mutation, you first call `useAddResponsibleToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResponsibleToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResponsibleToUserMutation, { data, loading, error }] = useAddResponsibleToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddResponsibleToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>(AddResponsibleToUserDocument, options);
      }
export type AddResponsibleToUserMutationHookResult = ReturnType<typeof useAddResponsibleToUserMutation>;
export type AddResponsibleToUserMutationResult = Apollo.MutationResult<AddResponsibleToUserMutation>;
export type AddResponsibleToUserMutationOptions = Apollo.BaseMutationOptions<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>;
export const AddRatingToUserDocument = gql`
    mutation AddRatingToUser($userId: String!, $rating: RatingScale!) {
  addRatingToUser(userId: $userId, rating: $rating)
}
    `;
export type AddRatingToUserMutationFn = Apollo.MutationFunction<AddRatingToUserMutation, AddRatingToUserMutationVariables>;

/**
 * __useAddRatingToUserMutation__
 *
 * To run a mutation, you first call `useAddRatingToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRatingToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRatingToUserMutation, { data, loading, error }] = useAddRatingToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useAddRatingToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddRatingToUserMutation, AddRatingToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRatingToUserMutation, AddRatingToUserMutationVariables>(AddRatingToUserDocument, options);
      }
export type AddRatingToUserMutationHookResult = ReturnType<typeof useAddRatingToUserMutation>;
export type AddRatingToUserMutationResult = Apollo.MutationResult<AddRatingToUserMutation>;
export type AddRatingToUserMutationOptions = Apollo.BaseMutationOptions<AddRatingToUserMutation, AddRatingToUserMutationVariables>;
export const AddCommentToUserDocument = gql`
    mutation AddCommentToUser($userId: String!, $comment: String!) {
  addCommentToUser(userId: $userId, comment: $comment)
}
    `;
export type AddCommentToUserMutationFn = Apollo.MutationFunction<AddCommentToUserMutation, AddCommentToUserMutationVariables>;

/**
 * __useAddCommentToUserMutation__
 *
 * To run a mutation, you first call `useAddCommentToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentToUserMutation, { data, loading, error }] = useAddCommentToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentToUserMutation, AddCommentToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentToUserMutation, AddCommentToUserMutationVariables>(AddCommentToUserDocument, options);
      }
export type AddCommentToUserMutationHookResult = ReturnType<typeof useAddCommentToUserMutation>;
export type AddCommentToUserMutationResult = Apollo.MutationResult<AddCommentToUserMutation>;
export type AddCommentToUserMutationOptions = Apollo.BaseMutationOptions<AddCommentToUserMutation, AddCommentToUserMutationVariables>;
export const GetCreateClaimOnFormResponseDocument = gql`
    query GetCreateClaimOnFormResponse($payload: CreateClaimOnDocumentPayload!) {
  getCreateClaimOnFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateClaimOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateClaimOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateClaimOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateClaimOnFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateClaimOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>(GetCreateClaimOnFormResponseDocument, options);
      }
export function useGetCreateClaimOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>(GetCreateClaimOnFormResponseDocument, options);
        }
export type GetCreateClaimOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateClaimOnFormResponseQuery>;
export type GetCreateClaimOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateClaimOnFormResponseLazyQuery>;
export type GetCreateClaimOnFormResponseQueryResult = Apollo.QueryResult<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>;
export const GetEditClaimOnFormResponseDocument = gql`
    query GetEditClaimOnFormResponse($objectId: String!) {
  getEditClaimOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditClaimOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditClaimOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditClaimOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditClaimOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditClaimOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>(GetEditClaimOnFormResponseDocument, options);
      }
export function useGetEditClaimOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>(GetEditClaimOnFormResponseDocument, options);
        }
export type GetEditClaimOnFormResponseQueryHookResult = ReturnType<typeof useGetEditClaimOnFormResponseQuery>;
export type GetEditClaimOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditClaimOnFormResponseLazyQuery>;
export type GetEditClaimOnFormResponseQueryResult = Apollo.QueryResult<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>;
export const GetEditFarmerOnDocumentFormResponseDocument = gql`
    query GetEditFarmerOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditFarmerOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditFarmerOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditFarmerOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditFarmerOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditFarmerOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditFarmerOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>(GetEditFarmerOnDocumentFormResponseDocument, options);
      }
export function useGetEditFarmerOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>(GetEditFarmerOnDocumentFormResponseDocument, options);
        }
export type GetEditFarmerOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditFarmerOnDocumentFormResponseQuery>;
export type GetEditFarmerOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditFarmerOnDocumentFormResponseLazyQuery>;
export type GetEditFarmerOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>;
export const GetEditFinancialResponsibleOnDocumentFormResponseDocument = gql`
    query getEditFinancialResponsibleOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditFinancialResponsibleOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditFinancialResponsibleOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditFinancialResponsibleOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditFinancialResponsibleOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditFinancialResponsibleOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditFinancialResponsibleOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>(GetEditFinancialResponsibleOnDocumentFormResponseDocument, options);
      }
export function useGetEditFinancialResponsibleOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>(GetEditFinancialResponsibleOnDocumentFormResponseDocument, options);
        }
export type GetEditFinancialResponsibleOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditFinancialResponsibleOnDocumentFormResponseQuery>;
export type GetEditFinancialResponsibleOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditFinancialResponsibleOnDocumentFormResponseLazyQuery>;
export type GetEditFinancialResponsibleOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>;
export const GetEditCropOnDocumentFormResponseDocument = gql`
    query GetEditCropOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditCropOnDocumentFormResponse(objectId: $objectId, documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditCropOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditCropOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditCropOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditCropOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditCropOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>(GetEditCropOnDocumentFormResponseDocument, options);
      }
export function useGetEditCropOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>(GetEditCropOnDocumentFormResponseDocument, options);
        }
export type GetEditCropOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditCropOnDocumentFormResponseQuery>;
export type GetEditCropOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditCropOnDocumentFormResponseLazyQuery>;
export type GetEditCropOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>;
export const ListDocumentsDocument = gql`
    query listDocuments($filter: [[DocumentsFilterInput]]!) {
  documents(filter: $filter) {
    _id
    stage
    status
    createdAt
    commercialResponsibleId
    commercialResponsible {
      nome
    }
    operationalResponsibleId
    operationalResponsible {
      nome
    }
    originatorId
    originator {
      nome
    }
    farmer {
      name
    }
    crop {
      cultureName
      culture {
        name
      }
      area
    }
    property {
      address {
        city
        state
      }
    }
  }
}
    `;

/**
 * __useListDocumentsQuery__
 *
 * To run a query within a React component, call `useListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
      }
export function useListDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
        }
export type ListDocumentsQueryHookResult = ReturnType<typeof useListDocumentsQuery>;
export type ListDocumentsLazyQueryHookResult = ReturnType<typeof useListDocumentsLazyQuery>;
export type ListDocumentsQueryResult = Apollo.QueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export const CountDocumentsDocument = gql`
    query CountDocuments($filter: [[DocumentsFilterInput]]!) {
  countDocuments(filter: $filter)
}
    `;

/**
 * __useCountDocumentsQuery__
 *
 * To run a query within a React component, call `useCountDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountDocumentsQuery(baseOptions: Apollo.QueryHookOptions<CountDocumentsQuery, CountDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountDocumentsQuery, CountDocumentsQueryVariables>(CountDocumentsDocument, options);
      }
export function useCountDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountDocumentsQuery, CountDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountDocumentsQuery, CountDocumentsQueryVariables>(CountDocumentsDocument, options);
        }
export type CountDocumentsQueryHookResult = ReturnType<typeof useCountDocumentsQuery>;
export type CountDocumentsLazyQueryHookResult = ReturnType<typeof useCountDocumentsLazyQuery>;
export type CountDocumentsQueryResult = Apollo.QueryResult<CountDocumentsQuery, CountDocumentsQueryVariables>;
export const GetComplementaryDataFormResponseDocument = gql`
    query GetComplementaryDataFormResponse($objectId: String!) {
  getComplementaryDataFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetComplementaryDataFormResponseQuery__
 *
 * To run a query within a React component, call `useGetComplementaryDataFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplementaryDataFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplementaryDataFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetComplementaryDataFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>(GetComplementaryDataFormResponseDocument, options);
      }
export function useGetComplementaryDataFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>(GetComplementaryDataFormResponseDocument, options);
        }
export type GetComplementaryDataFormResponseQueryHookResult = ReturnType<typeof useGetComplementaryDataFormResponseQuery>;
export type GetComplementaryDataFormResponseLazyQueryHookResult = ReturnType<typeof useGetComplementaryDataFormResponseLazyQuery>;
export type GetComplementaryDataFormResponseQueryResult = Apollo.QueryResult<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>;
export const GetEditPaymentDataOnDocumentFormResponseDocument = gql`
    query getEditPaymentDataOnDocumentFormResponse($objectId: String!) {
  getEditPaymentDataOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPaymentDataOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPaymentDataOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPaymentDataOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPaymentDataOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPaymentDataOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>(GetEditPaymentDataOnDocumentFormResponseDocument, options);
      }
export function useGetEditPaymentDataOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>(GetEditPaymentDataOnDocumentFormResponseDocument, options);
        }
export type GetEditPaymentDataOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPaymentDataOnDocumentFormResponseQuery>;
export type GetEditPaymentDataOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPaymentDataOnDocumentFormResponseLazyQuery>;
export type GetEditPaymentDataOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>;
export const GetDocumentDetailsDocument = gql`
    query GetDocumentDetails($docId: String!) {
  document(docId: $docId) {
    _id
    createdAt
    updatedAt
    stage
    status
    selectedResultIds
    justificationMessage
    insuranceTypeGroup
    commercialResponsibleId
    operationalResponsibleId
    originatorId
    premium
    archived
    proposalResultId
    visitPerson {
      name
    }
    costNFFiles {
      fileName
      fileKey
    }
    kmlFile {
      fileName
      fileKey
    }
    firstBillFile {
      fileName
      fileKey
    }
    crop {
      _id
      area
      cultureName
      harvestStartDate
      harvestEndDate
      culture {
        name
      }
      cultureDetail {
        name
      }
      manualCulture
      kmlFile {
        fileName
        fileKey
      }
      compositionType
      cropYear
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
      }
    }
    farmer {
      _id
      name
      cpfCnpj
      mobilePhone
      email
      rg
      emissionInstitution
      expeditionDate
      civilState
      gender
      birthDate
      profession
      documentFile {
        fileName
        fileKey
      }
      addressProofFile {
        fileName
        fileKey
      }
      address {
        city
        state
        street
        number
        complement
        cep
      }
    }
    property {
      _id
      accessInstructions
      address {
        city
        state
        street
        number
        complement
        cep
      }
      entranceLocation
      name
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
      }
    }
    simulationResults {
      _id
      externalId
      status
      error
      name
      provider
      basicCoverageType
      guaranteedProductivity
      coverages {
        name
        lmi
        premium
        coverageTags
      }
      amounts {
        lmi
        totalPremium
        stateSubvention
        federalSubvention
        finalPremium
        maxPayments
      }
    }
    selectedSimulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      coverages {
        name
        lmi
        premium
        coverageTags
      }
    }
    proposalResult {
      _id
      externalId
      name
      provider
      basicCoverageType
      guaranteedProductivity
      proposalFile {
        fileName
        fileKey
      }
      firstBillFile {
        fileName
        fileKey
      }
      signedProposalFile {
        _id
        fileName
        fileKey
      }
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      coverages {
        name
        lmi
        premium
        coverageTags
      }
    }
    beneficiary {
      _id
      name
      cpfCnpj
      mobilePhone
      email
      rg
      emissionInstitution
      expeditionDate
      civilState
      gender
      birthDate
      profession
      documentFile {
        fileName
        fileKey
      }
      addressProofFile {
        fileName
        fileKey
      }
      address {
        city
        state
        street
        number
        complement
        cep
      }
    }
    allowedVisitPeople {
      name
      cpfCnpj
      mobilePhone
      email
    }
    policy {
      _id
      endDate
      startDate
      externalId
      billsFile {
        fileName
        fileKey
      }
      policyFile {
        fileName
        fileKey
      }
    }
    paymentData {
      method
      responsibleId
      installments
      accountData {
        bank
        agency
        account
      }
      responsible {
        _id
        name
        cpfCnpj
        mobilePhone
        email
        rg
        emissionInstitution
        expeditionDate
        civilState
        gender
        birthDate
        profession
        documentFile {
          fileName
          fileKey
        }
        addressProofFile {
          fileName
          fileKey
        }
        address {
          city
          state
          street
          number
          complement
          cep
        }
      }
    }
    payments {
      _id
      responsibleId
      provider
      name
      dateDue
      amount
      status
      subventionType
    }
    archivedProposals {
      _id
      externalId
      provider
      basicCoverageType
      type
      insuranceTypeGroup
      guaranteedProductivity
    }
    claims {
      _id
      name
      externalId
      status
      events
      plots {
        _id
        name
        area
      }
      startDate
      endDate
      lossEstimate
      comment
      createdAt
    }
    inspections {
      _id
      documentId
      type
      date
      regulatoryAgency
      claims {
        name
      }
      inspector {
        name
        mobilePhone
      }
    }
  }
}
    `;

/**
 * __useGetDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useGetDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
      }
export function useGetDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
export type GetDocumentDetailsQueryHookResult = ReturnType<typeof useGetDocumentDetailsQuery>;
export type GetDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsLazyQuery>;
export type GetDocumentDetailsQueryResult = Apollo.QueryResult<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>;
export const GetDirectDocumentDetailsDocument = gql`
    query GetDirectDocumentDetails($docId: String!) {
  document(docId: $docId) {
    _id
    stage
    status
    justificationMessage
    insuranceTypeGroup
    premium
    createdAt
    crop {
      area
      cultureName
      culture {
        name
      }
      cultureDetail {
        name
      }
      manualCulture
    }
    farmer {
      name
      cpfCnpj
    }
    property {
      name
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
      }
      address {
        city
        state
      }
    }
    selectedSimulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      coverages {
        name
        lmi
        premium
        coverageTags
      }
    }
  }
}
    `;

/**
 * __useGetDirectDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDirectDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useGetDirectDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>(GetDirectDocumentDetailsDocument, options);
      }
export function useGetDirectDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>(GetDirectDocumentDetailsDocument, options);
        }
export type GetDirectDocumentDetailsQueryHookResult = ReturnType<typeof useGetDirectDocumentDetailsQuery>;
export type GetDirectDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDirectDocumentDetailsLazyQuery>;
export type GetDirectDocumentDetailsQueryResult = Apollo.QueryResult<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>;
export const GetFormResponseDocument = gql`
    query GetFormResponse($formResponseId: String!) {
  getFormResponse(formResponseId: $formResponseId) {
    formData
    formState
    errors
  }
}
    `;

/**
 * __useGetFormResponseQuery__
 *
 * To run a query within a React component, call `useGetFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponseQuery({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useGetFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetFormResponseQuery, GetFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormResponseQuery, GetFormResponseQueryVariables>(GetFormResponseDocument, options);
      }
export function useGetFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormResponseQuery, GetFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormResponseQuery, GetFormResponseQueryVariables>(GetFormResponseDocument, options);
        }
export type GetFormResponseQueryHookResult = ReturnType<typeof useGetFormResponseQuery>;
export type GetFormResponseLazyQueryHookResult = ReturnType<typeof useGetFormResponseLazyQuery>;
export type GetFormResponseQueryResult = Apollo.QueryResult<GetFormResponseQuery, GetFormResponseQueryVariables>;
export const GetCreateObjectFormResponseDocument = gql`
    query GetCreateObjectFormResponse($service: Services!, $formId: String!, $payload: JSON!) {
  getCreateObjectFormResponse(
    service: $service
    formId: $formId
    payload: $payload
  )
}
    `;

/**
 * __useGetCreateObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateObjectFormResponseQuery({
 *   variables: {
 *      service: // value for 'service'
 *      formId: // value for 'formId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>(GetCreateObjectFormResponseDocument, options);
      }
export function useGetCreateObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>(GetCreateObjectFormResponseDocument, options);
        }
export type GetCreateObjectFormResponseQueryHookResult = ReturnType<typeof useGetCreateObjectFormResponseQuery>;
export type GetCreateObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateObjectFormResponseLazyQuery>;
export type GetCreateObjectFormResponseQueryResult = Apollo.QueryResult<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>;
export const GetEditObjectFormResponseDocument = gql`
    query GetEditObjectFormResponse($service: Services!, $formId: String!, $objectId: String!, $metadata: JSON) {
  getEditObjectFormResponse(
    service: $service
    formId: $formId
    objectId: $objectId
    metadata: $metadata
  )
}
    `;

/**
 * __useGetEditObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditObjectFormResponseQuery({
 *   variables: {
 *      service: // value for 'service'
 *      formId: // value for 'formId'
 *      objectId: // value for 'objectId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useGetEditObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>(GetEditObjectFormResponseDocument, options);
      }
export function useGetEditObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>(GetEditObjectFormResponseDocument, options);
        }
export type GetEditObjectFormResponseQueryHookResult = ReturnType<typeof useGetEditObjectFormResponseQuery>;
export type GetEditObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditObjectFormResponseLazyQuery>;
export type GetEditObjectFormResponseQueryResult = Apollo.QueryResult<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>;
export const GetShareTokenDocument = gql`
    query GetShareToken($service: Services!, $objectId: String!) {
  getShareToken(service: $service, objectId: $objectId)
}
    `;

/**
 * __useGetShareTokenQuery__
 *
 * To run a query within a React component, call `useGetShareTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareTokenQuery({
 *   variables: {
 *      service: // value for 'service'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetShareTokenQuery(baseOptions: Apollo.QueryHookOptions<GetShareTokenQuery, GetShareTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareTokenQuery, GetShareTokenQueryVariables>(GetShareTokenDocument, options);
      }
export function useGetShareTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareTokenQuery, GetShareTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareTokenQuery, GetShareTokenQueryVariables>(GetShareTokenDocument, options);
        }
export type GetShareTokenQueryHookResult = ReturnType<typeof useGetShareTokenQuery>;
export type GetShareTokenLazyQueryHookResult = ReturnType<typeof useGetShareTokenLazyQuery>;
export type GetShareTokenQueryResult = Apollo.QueryResult<GetShareTokenQuery, GetShareTokenQueryVariables>;
export const GetMany2XOptionsDocument = gql`
    query GetMany2XOptions($serviceName: Services!, $domain: JSON!, $searchTerm: String!, $currentValue: [String]) {
  getMany2XOptions(
    serviceName: $serviceName
    domain: $domain
    searchTerm: $searchTerm
    currentValue: $currentValue
  ) {
    label
    value
  }
}
    `;

/**
 * __useGetMany2XOptionsQuery__
 *
 * To run a query within a React component, call `useGetMany2XOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMany2XOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMany2XOptionsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      domain: // value for 'domain'
 *      searchTerm: // value for 'searchTerm'
 *      currentValue: // value for 'currentValue'
 *   },
 * });
 */
export function useGetMany2XOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>(GetMany2XOptionsDocument, options);
      }
export function useGetMany2XOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>(GetMany2XOptionsDocument, options);
        }
export type GetMany2XOptionsQueryHookResult = ReturnType<typeof useGetMany2XOptionsQuery>;
export type GetMany2XOptionsLazyQueryHookResult = ReturnType<typeof useGetMany2XOptionsLazyQuery>;
export type GetMany2XOptionsQueryResult = Apollo.QueryResult<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>;
export const GetCreateInspectionOnFormResponseDocument = gql`
    query GetCreateInspectionOnFormResponse($payload: CreateInspectionOnDocumentPayload!) {
  getCreateInspectionOnFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateInspectionOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateInspectionOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateInspectionOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateInspectionOnFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateInspectionOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>(GetCreateInspectionOnFormResponseDocument, options);
      }
export function useGetCreateInspectionOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>(GetCreateInspectionOnFormResponseDocument, options);
        }
export type GetCreateInspectionOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateInspectionOnFormResponseQuery>;
export type GetCreateInspectionOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateInspectionOnFormResponseLazyQuery>;
export type GetCreateInspectionOnFormResponseQueryResult = Apollo.QueryResult<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>;
export const GetEditInspectionOnFormResponseDocument = gql`
    query GetEditInspectionOnFormResponse($objectId: String!, $documentId: String!) {
  getEditInspectionOnFormResponse(objectId: $objectId, documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditInspectionOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditInspectionOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditInspectionOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditInspectionOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditInspectionOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>(GetEditInspectionOnFormResponseDocument, options);
      }
export function useGetEditInspectionOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>(GetEditInspectionOnFormResponseDocument, options);
        }
export type GetEditInspectionOnFormResponseQueryHookResult = ReturnType<typeof useGetEditInspectionOnFormResponseQuery>;
export type GetEditInspectionOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditInspectionOnFormResponseLazyQuery>;
export type GetEditInspectionOnFormResponseQueryResult = Apollo.QueryResult<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>;
export const ListLeadsDocument = gql`
    query listLeads($filter: [[LeadFiltersInput]]!) {
  leads(filter: $filter) {
    _id
    area
    address {
      city
      state
      cep
    }
    type
    status
    name
    createdAt
    rating
    cultures {
      _id
      name
    }
  }
}
    `;

/**
 * __useListLeadsQuery__
 *
 * To run a query within a React component, call `useListLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListLeadsQuery(baseOptions: Apollo.QueryHookOptions<ListLeadsQuery, ListLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLeadsQuery, ListLeadsQueryVariables>(ListLeadsDocument, options);
      }
export function useListLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLeadsQuery, ListLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLeadsQuery, ListLeadsQueryVariables>(ListLeadsDocument, options);
        }
export type ListLeadsQueryHookResult = ReturnType<typeof useListLeadsQuery>;
export type ListLeadsLazyQueryHookResult = ReturnType<typeof useListLeadsLazyQuery>;
export type ListLeadsQueryResult = Apollo.QueryResult<ListLeadsQuery, ListLeadsQueryVariables>;
export const CountLeadsDocument = gql`
    query CountLeads($filter: [[LeadFiltersInput]]!) {
  countLeads(filter: $filter)
}
    `;

/**
 * __useCountLeadsQuery__
 *
 * To run a query within a React component, call `useCountLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountLeadsQuery(baseOptions: Apollo.QueryHookOptions<CountLeadsQuery, CountLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountLeadsQuery, CountLeadsQueryVariables>(CountLeadsDocument, options);
      }
export function useCountLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountLeadsQuery, CountLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountLeadsQuery, CountLeadsQueryVariables>(CountLeadsDocument, options);
        }
export type CountLeadsQueryHookResult = ReturnType<typeof useCountLeadsQuery>;
export type CountLeadsLazyQueryHookResult = ReturnType<typeof useCountLeadsLazyQuery>;
export type CountLeadsQueryResult = Apollo.QueryResult<CountLeadsQuery, CountLeadsQueryVariables>;
export const GetLeadDetailsDocument = gql`
    query GetLeadDetails($leadId: String!) {
  lead(leadId: $leadId) {
    _id
    type
    status
    name
    area
    address {
      city
      state
      street
    }
    comments
    createdAt
    email
    linkedin
    meetingIds
    phone
    rating
    commercialResponsibleId
    technicalResponsibleId
    cultures {
      _id
      name
    }
    meetings {
      _id
      status
      responsible {
        nome
      }
      date
      topic
      comment
      attachment
    }
  }
}
    `;

/**
 * __useGetLeadDetailsQuery__
 *
 * To run a query within a React component, call `useGetLeadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDetailsQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetLeadDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
      }
export function useGetLeadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
        }
export type GetLeadDetailsQueryHookResult = ReturnType<typeof useGetLeadDetailsQuery>;
export type GetLeadDetailsLazyQueryHookResult = ReturnType<typeof useGetLeadDetailsLazyQuery>;
export type GetLeadDetailsQueryResult = Apollo.QueryResult<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>;
export const GetEditLeadOnFormResponseDocument = gql`
    query GetEditLeadOnFormResponse($objectId: String!) {
  getEditLeadOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditLeadOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditLeadOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditLeadOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditLeadOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditLeadOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>(GetEditLeadOnFormResponseDocument, options);
      }
export function useGetEditLeadOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>(GetEditLeadOnFormResponseDocument, options);
        }
export type GetEditLeadOnFormResponseQueryHookResult = ReturnType<typeof useGetEditLeadOnFormResponseQuery>;
export type GetEditLeadOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditLeadOnFormResponseLazyQuery>;
export type GetEditLeadOnFormResponseQueryResult = Apollo.QueryResult<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>;
export const GetCreateMeetingOnObjectFormResponseDocument = gql`
    query GetCreateMeetingOnObjectFormResponse($payload: CreateMeetingOnObjectPayload!) {
  getCreateMeetingOnObjectFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateMeetingOnObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateMeetingOnObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateMeetingOnObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateMeetingOnObjectFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateMeetingOnObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>(GetCreateMeetingOnObjectFormResponseDocument, options);
      }
export function useGetCreateMeetingOnObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>(GetCreateMeetingOnObjectFormResponseDocument, options);
        }
export type GetCreateMeetingOnObjectFormResponseQueryHookResult = ReturnType<typeof useGetCreateMeetingOnObjectFormResponseQuery>;
export type GetCreateMeetingOnObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateMeetingOnObjectFormResponseLazyQuery>;
export type GetCreateMeetingOnObjectFormResponseQueryResult = Apollo.QueryResult<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>;
export const GetEditMeetingOnObjectFormResponseDocument = gql`
    query GetEditMeetingOnObjectFormResponse($objectId: String!) {
  getEditMeetingOnObjectFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditMeetingOnObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditMeetingOnObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditMeetingOnObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditMeetingOnObjectFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditMeetingOnObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>(GetEditMeetingOnObjectFormResponseDocument, options);
      }
export function useGetEditMeetingOnObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>(GetEditMeetingOnObjectFormResponseDocument, options);
        }
export type GetEditMeetingOnObjectFormResponseQueryHookResult = ReturnType<typeof useGetEditMeetingOnObjectFormResponseQuery>;
export type GetEditMeetingOnObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditMeetingOnObjectFormResponseLazyQuery>;
export type GetEditMeetingOnObjectFormResponseQueryResult = Apollo.QueryResult<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>;
export const NotesDocument = gql`
    query Notes($docId: String!, $serviceName: Services!) {
  notes(docId: $docId, serviceName: $serviceName) {
    text
    createdAt
    serviceName
    authorId {
      nome
    }
  }
}
    `;

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useNotesQuery(baseOptions: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
      }
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>;
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>;
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($serviceName: Services!) {
  notifications(serviceName: $serviceName) {
    createdAt
    data {
      notificationGroup
      data {
        objectId
        serviceName
        createdAt
        text
        originInfo
        author {
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const GetCreatePaymentOnDocumentFormResponseDocument = gql`
    query GetCreatePaymentOnDocumentFormResponse($payload: CreatePaymentOnDocumentPayload!) {
  getCreatePaymentOnDocumentFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreatePaymentOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreatePaymentOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatePaymentOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatePaymentOnDocumentFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreatePaymentOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>(GetCreatePaymentOnDocumentFormResponseDocument, options);
      }
export function useGetCreatePaymentOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>(GetCreatePaymentOnDocumentFormResponseDocument, options);
        }
export type GetCreatePaymentOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreatePaymentOnDocumentFormResponseQuery>;
export type GetCreatePaymentOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreatePaymentOnDocumentFormResponseLazyQuery>;
export type GetCreatePaymentOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>;
export const GetEditPaymentOnDocumentFormResponseDocument = gql`
    query GetEditPaymentOnDocumentFormResponse($objectId: String!) {
  getEditPaymentOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPaymentOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPaymentOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPaymentOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPaymentOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPaymentOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>(GetEditPaymentOnDocumentFormResponseDocument, options);
      }
export function useGetEditPaymentOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>(GetEditPaymentOnDocumentFormResponseDocument, options);
        }
export type GetEditPaymentOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPaymentOnDocumentFormResponseQuery>;
export type GetEditPaymentOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPaymentOnDocumentFormResponseLazyQuery>;
export type GetEditPaymentOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>;
export const GetCreatePolicyOnDocumentFormResponseDocument = gql`
    query GetCreatePolicyOnDocumentFormResponse($payload: CreatePolicyOnDocumentPayload!) {
  getCreatePolicyOnDocumentFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreatePolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreatePolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatePolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatePolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreatePolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>(GetCreatePolicyOnDocumentFormResponseDocument, options);
      }
export function useGetCreatePolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>(GetCreatePolicyOnDocumentFormResponseDocument, options);
        }
export type GetCreatePolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreatePolicyOnDocumentFormResponseQuery>;
export type GetCreatePolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreatePolicyOnDocumentFormResponseLazyQuery>;
export type GetCreatePolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>;
export const GetEditPolicyOnDocumentFormResponseDocument = gql`
    query GetEditPolicyOnDocumentFormResponse($objectId: String!) {
  getEditPolicyOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>(GetEditPolicyOnDocumentFormResponseDocument, options);
      }
export function useGetEditPolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>(GetEditPolicyOnDocumentFormResponseDocument, options);
        }
export type GetEditPolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPolicyOnDocumentFormResponseQuery>;
export type GetEditPolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPolicyOnDocumentFormResponseLazyQuery>;
export type GetEditPolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>;
export const GetEditPropertyOnDocumentFormResponseDocument = gql`
    query GetEditPropertyOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditPropertyOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPropertyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPropertyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPropertyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPropertyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditPropertyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>(GetEditPropertyOnDocumentFormResponseDocument, options);
      }
export function useGetEditPropertyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>(GetEditPropertyOnDocumentFormResponseDocument, options);
        }
export type GetEditPropertyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPropertyOnDocumentFormResponseQuery>;
export type GetEditPropertyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPropertyOnDocumentFormResponseLazyQuery>;
export type GetEditPropertyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>;
export const GetCreateProposalOnDocumentFormResponseDocument = gql`
    query GetCreateProposalOnDocumentFormResponse($payload: CreateProposalOnDocumentPayload!) {
  getCreateProposalOnDocumentFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateProposalOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateProposalOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateProposalOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateProposalOnDocumentFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateProposalOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>(GetCreateProposalOnDocumentFormResponseDocument, options);
      }
export function useGetCreateProposalOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>(GetCreateProposalOnDocumentFormResponseDocument, options);
        }
export type GetCreateProposalOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateProposalOnDocumentFormResponseQuery>;
export type GetCreateProposalOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateProposalOnDocumentFormResponseLazyQuery>;
export type GetCreateProposalOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>;
export const GetCreateResultOnDocumentFormResponseDocument = gql`
    query GetCreateResultOnDocumentFormResponse($payload: CreateResultOnDocumentPayload!) {
  getCreateResultOnDocumentFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateResultOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateResultOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateResultOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateResultOnDocumentFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateResultOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>(GetCreateResultOnDocumentFormResponseDocument, options);
      }
export function useGetCreateResultOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>(GetCreateResultOnDocumentFormResponseDocument, options);
        }
export type GetCreateResultOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateResultOnDocumentFormResponseQuery>;
export type GetCreateResultOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateResultOnDocumentFormResponseLazyQuery>;
export type GetCreateResultOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>;
export const GetEditProposalOnDocumentFormResponseDocument = gql`
    query GetEditProposalOnDocumentFormResponse($objectId: String!) {
  getEditProposalOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditProposalOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditProposalOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditProposalOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditProposalOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditProposalOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>(GetEditProposalOnDocumentFormResponseDocument, options);
      }
export function useGetEditProposalOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>(GetEditProposalOnDocumentFormResponseDocument, options);
        }
export type GetEditProposalOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditProposalOnDocumentFormResponseQuery>;
export type GetEditProposalOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditProposalOnDocumentFormResponseLazyQuery>;
export type GetEditProposalOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>;
export const GetEditResultOnDocumentFormResponseDocument = gql`
    query GetEditResultOnDocumentFormResponse($objectId: String!) {
  getEditResultOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditResultOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditResultOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditResultOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditResultOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditResultOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>(GetEditResultOnDocumentFormResponseDocument, options);
      }
export function useGetEditResultOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>(GetEditResultOnDocumentFormResponseDocument, options);
        }
export type GetEditResultOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditResultOnDocumentFormResponseQuery>;
export type GetEditResultOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditResultOnDocumentFormResponseLazyQuery>;
export type GetEditResultOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>;
export const GetCreateSignedProposalOnFormResponseDocument = gql`
    query getCreateSignedProposalOnFormResponse($payload: CreateSignedProposalOnResultPayload!) {
  getCreateSignedProposalOnFormResponse(payload: $payload) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateSignedProposalOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateSignedProposalOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateSignedProposalOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateSignedProposalOnFormResponseQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateSignedProposalOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>(GetCreateSignedProposalOnFormResponseDocument, options);
      }
export function useGetCreateSignedProposalOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>(GetCreateSignedProposalOnFormResponseDocument, options);
        }
export type GetCreateSignedProposalOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateSignedProposalOnFormResponseQuery>;
export type GetCreateSignedProposalOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateSignedProposalOnFormResponseLazyQuery>;
export type GetCreateSignedProposalOnFormResponseQueryResult = Apollo.QueryResult<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>;
export const GetEditSignedProposalOnFormResponseDocument = gql`
    query GetEditSignedProposalOnFormResponse($objectId: String!) {
  getEditSignedProposalOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditSignedProposalOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditSignedProposalOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditSignedProposalOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditSignedProposalOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditSignedProposalOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>(GetEditSignedProposalOnFormResponseDocument, options);
      }
export function useGetEditSignedProposalOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>(GetEditSignedProposalOnFormResponseDocument, options);
        }
export type GetEditSignedProposalOnFormResponseQueryHookResult = ReturnType<typeof useGetEditSignedProposalOnFormResponseQuery>;
export type GetEditSignedProposalOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditSignedProposalOnFormResponseLazyQuery>;
export type GetEditSignedProposalOnFormResponseQueryResult = Apollo.QueryResult<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>;
export const ModelTasksDocument = gql`
    query ModelTasks($serviceName: Services!, $objectId: String) {
  modelTasks(serviceName: $serviceName, objectId: $objectId) {
    modelName
    message
    docId
    dateDue
    responsible {
      nome
    }
    originInfo
  }
}
    `;

/**
 * __useModelTasksQuery__
 *
 * To run a query within a React component, call `useModelTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTasksQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useModelTasksQuery(baseOptions: Apollo.QueryHookOptions<ModelTasksQuery, ModelTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelTasksQuery, ModelTasksQueryVariables>(ModelTasksDocument, options);
      }
export function useModelTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelTasksQuery, ModelTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelTasksQuery, ModelTasksQueryVariables>(ModelTasksDocument, options);
        }
export type ModelTasksQueryHookResult = ReturnType<typeof useModelTasksQuery>;
export type ModelTasksLazyQueryHookResult = ReturnType<typeof useModelTasksLazyQuery>;
export type ModelTasksQueryResult = Apollo.QueryResult<ModelTasksQuery, ModelTasksQueryVariables>;
export const ListUsersDocument = gql`
    query listUsers($filter: [[PartnersFiltersInput]]!) {
  users(filter: $filter) {
    _id
    role
    status
    nome
    email
    city
    state
    disabled
    profession
    signedDate
    responsibleId
    createdAt
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const CountUsersDocument = gql`
    query CountUsers($filter: [[PartnersFiltersInput]]!) {
  countUsers(filter: $filter)
}
    `;

/**
 * __useCountUsersQuery__
 *
 * To run a query within a React component, call `useCountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountUsersQuery(baseOptions: Apollo.QueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
      }
export function useCountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
export type CountUsersQueryHookResult = ReturnType<typeof useCountUsersQuery>;
export type CountUsersLazyQueryHookResult = ReturnType<typeof useCountUsersLazyQuery>;
export type CountUsersQueryResult = Apollo.QueryResult<CountUsersQuery, CountUsersQueryVariables>;
export const GetUserDetailsDocument = gql`
    query GetUserDetails($userId: String!) {
  user(userId: $userId) {
    _id
    role
    status
    signedDate
    createdAt
    disabled
    username
    nome
    email
    disabled
    phone
    cpf
    rg
    civilState
    cep
    city
    state
    profession
    rating
    comments
    responsible {
      _id
      nome
    }
    meetings {
      _id
      status
      responsibleId
      responsible {
        nome
      }
      date
      topic
      comment
      attachment
    }
    indicators {
      _id
      totalArea
      totalPremium
      totalCommission
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const GetUserIndicatorsDocument = gql`
    query GetUserIndicators($userId: String!) {
  user(userId: $userId) {
    indicators {
      _id
      totalArea
      totalPremium
      totalCommission
    }
  }
}
    `;

/**
 * __useGetUserIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetUserIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIndicatorsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>(GetUserIndicatorsDocument, options);
      }
export function useGetUserIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>(GetUserIndicatorsDocument, options);
        }
export type GetUserIndicatorsQueryHookResult = ReturnType<typeof useGetUserIndicatorsQuery>;
export type GetUserIndicatorsLazyQueryHookResult = ReturnType<typeof useGetUserIndicatorsLazyQuery>;
export type GetUserIndicatorsQueryResult = Apollo.QueryResult<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>;